import { ref } from 'vue'
import router from '../router/index'

const detailDataList = ref(
    [
        {
            pageName: "SKY机型",
            dataId: "drone-1-1",
            data: {
                routerList: ["无人机", "SKY机型"],
                topImg: require("../assets/img/drone/ScenarioCard-1.png"),
                topFont: [
                    { fontSize: 'normal', value: "SKY机型" },
                ],
                content: [
                    { type: 'title', value: 'SKY机型 无人机' },
                    { type: 'text', value: 'SKY机型是一款高性能无人机，专为专业航拍和工业应用设计。搭载先进的飞控系统和高清摄像头，支持多种智能飞行模式，为用户提供稳定、精准的飞行体验。' },
                    { type: 'bigTitle', value: '产品特点' },
                    { type: 'text', value: '(1)高清航拍：配备4K超高清摄像头，支持120fps慢动作拍摄' },
                    { type: 'text', value: '(2)智能避障：采用多传感器融合技术，实现全方位智能避障' },
                    { type: 'text', value: '(3)长续航：采用高密度锂电池，续航时间可达45分钟' },
                    { type: 'text', value: '(4)精准定位：支持GPS+北斗双模定位，定位精度可达厘米级' },
                    { type: 'text', value: '(5)智能跟拍：支持目标识别和自动跟拍功能' },
                    { type: 'text', value: '(6)防水设计：IP43级防水，适应复杂天气环境' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '专业航拍、影视制作、测绘勘探、电力巡检、农业植保、应急救援' },
                ]
            }
        }, {
            pageName: "FLY机型",
            dataId: "drone-1-2",
            data: {
                routerList: ["无人机", "FLY机型"],
                topImg: require("../assets/img/drone/ScenarioCard-1.png"),
                topFont: [
                    { fontSize: 'normal', value: "FLY机型" },
                ],
                content: [
                    { type: 'title', value: 'FLY机型 无人机' },
                    { type: 'text', value: 'FLY机型是一款轻量化便携式无人机，专为个人娱乐和入门级航拍设计。操作简单，功能丰富，让每个人都能轻松享受飞行乐趣。' },
                    { type: 'bigTitle', value: '产品特点' },
                    { type: 'text', value: '(1)轻便易携：整机重量极轻，无需注册即可飞行' },
                    { type: 'text', value: '(2)一键起飞：支持一键起飞、一键降落、一键返航' },
                    { type: 'text', value: '(3)智能跟随：支持手势控制和智能跟随模式' },
                    { type: 'text', value: '(4)高清拍摄：配备高清摄像头，支持实时图传' },
                    { type: 'text', value: '(5)多种模式：支持环绕飞行、渐远飞行、螺旋飞行等多种智能模式' },
                    { type: 'text', value: '(6)长续航：续航时间持久' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '个人娱乐、旅行记录、家庭聚会、户外运动、Vlog拍摄' },
                ]
            }
        }, {
            pageName: "LARK机型",
            dataId: "drone-1-3",
            data: {
                routerList: ["无人机", "LARK机型"],
                topImg: require("../assets/img/drone/ScenarioCard-1.png"),
                topFont: [
                    { fontSize: 'normal', value: "LARK机型" },
                ],
                content: [
                    { type: 'title', value: 'LARK机型 无人机' },
                    { type: 'text', value: 'LARK机型是一款超小型口袋无人机，专为日常记录和社交分享设计。小巧精致，功能强大，让随时随地记录精彩瞬间成为可能。' },
                    { type: 'bigTitle', value: '产品特点' },
                    { type: 'text', value: '(1)超小体积：折叠后仅手掌大小，轻松放入口袋' },
                    { type: 'text', value: '(2)智能拍摄：支持AI场景识别和智能构图' },
                    { type: 'text', value: '(3)一键分享：支持实时分享到社交平台' },
                    { type: 'text', value: '(4)高清画质：配备高清摄像头，支持HDR拍摄' },
                    { type: 'text', value: '(5)智能防抖：采用三轴机械云台，拍摄更稳定' },
                    { type: 'text', value: '(6)快速充电：支持快充技术，充电时间短即可飞行' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '日常记录、社交分享、美食拍摄、宠物记录、旅行Vlog' },
                ]
            }
        }, {
            pageName: "飞控电调",
            dataId: "drone-1-4",
            data: {
                routerList: ["无人机", "飞控电调"],
                topImg: require("../assets/img/drone/ScenarioCard-1.png"),
                topFont: [
                    { fontSize: 'normal', value: "飞控电调" },
                ],
                content: [
                    { type: 'title', value: '飞控电调系统' },
                    { type: 'text', value: '飞控电调是无人机的核心控制系统，负责飞行姿态控制、电机驱动和动力分配。采用先进的控制算法和高效功率器件，为无人机提供稳定、精准的飞行控制。' },
                    { type: 'bigTitle', value: '产品特点' },
                    { type: 'text', value: '(1)高精度控制：采用高性能处理器，控制频率极高' },
                    { type: 'text', value: '(2)智能算法：支持PID控制、模糊控制等多种控制算法' },
                    { type: 'text', value: '(3)高效驱动：采用高效MOSFET，效率极高' },
                    { type: 'text', value: '(4)多重保护：支持过流、过压、过温、堵转等多重保护' },
                    { type: 'text', value: '(5)快速响应：响应时间极短，飞行更敏捷' },
                    { type: 'text', value: '(6)可编程：支持固件升级和参数调节' },
                    { type: 'bigTitle', value: '技术参数' },
                    { type: 'text', value: '输入电压：支持多档锂电池\n输出电流：持续电流大/峰值电流更高\n控制频率：极高\n重量：轻量化设计\n尺寸：紧凑型设计' },
                ]
            }
        }, {
            pageName: "接收机",
            dataId: "drone-1-5",
            data: {
                routerList: ["无人机", "接收机"],
                topImg: require("../assets/img/drone/ScenarioCard-1.png"),
                topFont: [
                    { fontSize: 'normal', value: "接收机" },
                ],
                content: [
                    { type: 'title', value: '无线接收机' },
                    { type: 'text', value: '无线接收机是无人机遥控系统的核心部件，负责接收遥控器的控制信号并传输给飞控系统。采用先进的无线通信技术，确保控制信号的稳定传输。' },
                    { type: 'bigTitle', value: '产品特点' },
                    { type: 'text', value: '(1)长距离传输：传输距离远' },
                    { type: 'text', value: '(2)低延迟：延迟时间极短，响应更及时' },
                    { type: 'text', value: '(3)抗干扰：采用跳频技术，抗干扰能力强' },
                    { type: 'text', value: '(4)多通道：支持多通道控制' },
                    { type: 'text', value: '(5)双天线：支持双天线接收，信号更稳定' },
                    { type: 'text', value: '(6)兼容性强：支持多种遥控器协议' },
                    { type: 'bigTitle', value: '技术参数' },
                    { type: 'text', value: '工作频率：2.4GHz\n传输距离：远距离传输\n通道数：多通道\n延迟：极低延迟\n重量：轻量化设计\n尺寸：紧凑型设计' },
                ]
            }
        }, {
            pageName: "数字图传",
            dataId: "drone-1-6",
            data: {
                routerList: ["无人机", "数字图传"],
                topImg: require("../assets/img/drone/ScenarioCard-1.png"),
                topFont: [
                    { fontSize: 'normal', value: "数字图传" },
                ],
                content: [
                    { type: 'title', value: '数字图传系统' },
                    { type: 'text', value: '数字图传系统是无人机的视频传输核心，负责将摄像头拍摄的高清视频实时传输到地面设备。采用先进的数字压缩和无线传输技术，确保视频的高质量传输。' },
                    { type: 'bigTitle', value: '产品特点' },
                    { type: 'text', value: '(1)高清传输：支持高清视频传输' },
                    { type: 'text', value: '(2)低延迟：视频延迟极低' },
                    { type: 'text', value: '(3)长距离：传输距离远' },
                    { type: 'text', value: '(4)抗干扰：采用自适应跳频技术，抗干扰能力强' },
                    { type: 'text', value: '(5)多设备：支持多设备同时观看' },
                    { type: 'text', value: '(6)低功耗：功耗低，续航更持久' },
                    { type: 'bigTitle', value: '技术参数' },
                    { type: 'text', value: '分辨率：高清\n传输距离：远距离\n延迟：极低\n工作频率：5.8GHz\n重量：轻量化设计\n尺寸：紧凑型设计' },
                ]
            }
        },
        {
            pageName: "智能座舱系统平台",
            dataId: "1-1-1",
            data: {
                routerList: ["产品","智能座舱系统平台"],
                topImg: require("../assets/img/smart_cockpit_platform.png"),
                topFont: [
                    // { fontSize: 'small', value: "车载操作系统定制开发" },
                    { fontSize: 'normal', value: "智能座舱系统平台" },
                ],

            }
        }, {
            pageName: "智能交互产品",
            dataId: "1-1-2",
            data: {
                routerList: ["产品", "智能座舱系统", "智能交互产品"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    // { fontSize: 'small', value: "智能交互产品" },
                    { fontSize: 'normal', value: "智能交互产品" },
                ],
                content: [
                    { type: 'title', value: '智能数字仪表' },
                    { type: 'text', value: '搭载 Renesas RH850 高性能车规级处理器，以 160MHz 至 240MHz 多核架构，为智能座舱注入强劲动力。5MB 超大 Flash 与 512KB RAM 组合，通过KanZi工具，支持复杂 UI 渲染、多任务并行处理及实时数据交互，从容应对智能驾驶辅助、导航娱乐等多元场景。' },
                    { type: 'image', src: require("../assets/img/product/product2.png") },
                    { type: 'title', value: '智能IVI中控娱乐系统解决方案' },
                    { type: 'text', value: '基于高通 SA8155P QNX+AndroidHypervisor 平台，为客户提供了基于 Kanzi 的中控及车模车控设计开发的解决方案。通过适配Android 12操作系统，包括文字、视觉、声觉、触觉和动作等交互方式的集成，涵盖多媒体、收音、蓝牙、互联等多个功能模块的 HMI、APP 以及中间件开发。支持安卓或自有应用，打造车企专属服务，实现数字共享。使功能满足日渐提高的用户需求。' },
                    { type: 'image', src: require("../assets/img/product/product3.png") },
                    { type: 'title', value: '有线/无线Carplay和Android Auto解决方案' },
                    { type: 'text', value: '通过 USB 或 Wi-Fi 与车机系统建立通信，支持语音控制、地图导航、音乐播放、短信、电话等功能。适配蓝牙5.0+和WiFi，满足Apple和Google产品认证。' },
                    {
                        type: 'twoImage', count: 2,
                        srcList: [
                            { name: null, src: require("../assets/img/product/product4.png") },
                            { name: null, src: require("../assets/img/product/product5.png") },]
                    },
                ]
            }
        }, {
            pageName: "智慧健康汽车",
            dataId: "1-1-3",
            data: {
                routerList: ["产品", "智能座舱系统", "智慧健康汽车"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    // { fontSize: 'small', value: "智慧健康汽车" },
                    // { fontSize: 'normal', value: "智慧健康汽车" },
                    { fontSize: 'normal', value: "智慧健康汽车" },
                ],
                content: [
                    { type: 'title', value: '智慧健康汽车' },
                    { type: 'text', value: '(1)智能穿戴联动，驾驶员健康体征监测提醒；DMS疲劳监测：驾驶员健康状态与车辆控制策略联动。' },
                    { type: 'text', value: '(2)空气质量管理：针对空气污染实时检测，联动空调主动净化；可配置香氛系统，支持香氛种类、浓度智能切换。' },
                    { type: 'text', value: '(3)声学健康管理：ANC主动降噪：多麦克风阵列+反向声波抵消技术，车内噪音降低；个性化声场：基于驾驶员耳廓特征的3D音效补偿算法，降低驾驶疲劳指数。' },
                    { type: 'image', src: require("../assets/img/product/product6.png") },
                ]
            }
        }, {
            pageName: "AUTOSAR解决方案",
            dataId: "1-2-1",
            data: {
                routerList: ["产品", "智能驾驶系统", "AUTOSAR解决方案"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    // { fontSize: 'small', value: "AUTOSAR解决方案" },
                    // { fontSize: 'normal', value: "AUTOSAR解决方案" },
                    { fontSize: 'normal', value: "AUTOSAR解决方案" },
                ],
                content: [
                    { type: 'title', value: 'AUTOSAR解决方案' },
                    { type: 'text', value: '全栈开发服务：双平台覆盖&模块化工具链。' },
                    { type: 'text', value: '国产化方案：适配普华ORIENTAIS AUTOSAR工具链，联合紫光国微、智芯科技打造RISC-V架构MCU解决方案，关键模块自主可控率100%，适配国产芯片生态需求。' },
                    { type: 'text', value: '国际化方案：适配Davinci AUTOSAR工具，为客户提供标准的 AUTOSAR CP/AP设计，降低开发与维护成本。' },
                    { type: 'image', src: require("../assets/img/product/product7.png") },
                ]
            }
        }, {
            pageName: "智能驾驶视觉系统",
            dataId: "1-2-2",
            data: {
                routerList: ["产品", "智能驾驶系统", "智能驾驶视觉系统"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    // { fontSize: 'small', value: "AUTOSAR解决方案" },
                    // { fontSize: 'normal', value: "AUTOSAR解决方案" },
                    { fontSize: 'normal', value: "智能驾驶视觉系统" },
                ],
                content: [
                    { type: 'title', value: '智能驾驶视觉系统' },
                    { type: 'bigTitle', value: 'AVM全景环视纯视觉感知系统' },
                    { type: 'text', value: '利用车身四周摄像头，拼接出以车身为中心的360°环视画面，直接鸟瞰车身周边情况。支持多种车型，采用4路（前后左右）摄像头方案。\nAVM算法消除畸变与色偏，支持曲面场景智能修正算法，确保画面精准还原。采用双核运算架构实现画质与效能的动态优化，智能适应复杂环境需求。方案成本较传统方案降低40%以上，特别适合经济型及主流中端车型规模化搭载。' },
                    { type: 'smallTitle', value: '产品优势' },
                    { type: 'text', value: '（1）成熟高效的视觉与影像处理技术，能平衡不同光线下的图像、无视摄像头倾角，提供更清晰真实的全景图像。\n（2）灵活适配多种车型。算法能够稳定运行，提供流畅的实时拼接效果视频。\n（3）算法识别精度表现出色，经大量场景数据训练，覆盖用例全面，运行稳定、健壮性强。' },
                    { type: 'bigTitle', value: 'CMS电子后视镜系统' },
                    { type: 'text', value: '通过安全可定制的软件方案与高性能硬件深度协同，实现全场景全天候可靠视觉感知，以软硬一体化创新重塑智能驾驶视觉体验。' },
                    { type: 'smallTitle', value: '产品优势' },
                    { type: 'text', value: '（1）高清流媒体后视镜是运用先进的实景显示技术，通过安装在车辆后部的全高清无畸变微光夜视广角全玻璃摄像头，将车身后方影像显示在后视镜显示大屏上，大广角摄像头可视角度达到传统后视镜的3倍以上，可视范围更远。\n（2）附加高清行车记录功能，远离碰瓷，清晰记录每一个行车瞬间。不仅可以遏止交通违章、约束驾驶员不良驾驶习惯,而且可以有效地预防道路交通事故的发生,并为执法人员进行事故的分析、处理提供科学、忠实的原始数据。\n（3）可以避免传统后视镜的视野和不同环境造成的盲区，例如雨雾天气、雪地等环境。' },
                    { type: 'smallTitle', value: '产品参数' },
                    { type: 'image', src: require("../assets/img/product/product8.png") },
                    { type: 'bigTitle', value: 'DMS驾驶员监测系统' },
                    { type: 'text', value: '通过自主研发的多模态感知技术，实时监测驾驶员疲劳、分心及情绪波动等风险状态。同步分析面部微表情、眼球轨迹、方向盘操作等数据维度，当检测到潜在危险时，可智能触发分级预警机制（声光提示/语音交互）或联动车辆主动安全系统，有效预防事故发生。方案通过国际ADDW认证标准，助力厂商快速构建符合海外市场准入要求的智能驾驶能力。' },
                    { type: 'bigTitle', value: '疲劳驾驶检测' },
                    { type: 'text', value: '对驾驶员脸部、眼部、体态等细节特征进行智能分析，帮助准确识别是否存在疲劳驾驶。可结合车速（一般默认车速＞20KM/h）、连续驾驶时长（交通法规定驾驶时长超过4小时要停车休息）、驾驶时间段（午后、夜间和凌晨是疲惫高发期）等维度，定义出疲劳监测等级报警策略，如：轻度疲劳、中度疲劳、高度疲劳，便于在不同的商用车使用场景下应用。' },
                    { type: 'bigTitle', value: '分心检测' },
                    { type: 'text', value: '行车过程中（一般默认车速＞20KM/h），当驾驶员出现分心的情况，诸如玩手机、找东西、回头聊天等行为，会触发系统报警提示。' },
                    { type: 'bigTitle', value: '危险驾驶检测' },
                    { type: 'text', value: '当行车过程中当驾驶员出现吸烟、接打电话等危险行为情况，会触发系统报警。' },
                    { type: 'bigTitle', value: '摄像头遮挡检测' },
                    { type: 'text', value: '对摄像头画面进行实时检测，当出现一定范围内的视频遮挡、黑屏等镜头异常情况时，触发摄像头遮挡预警。' },
                ]
            }
        }, {
            pageName: "行泊一体解决方案",
            dataId: "1-2-3",
            data: {
                routerList: ["产品", "智能驾驶系统", "行泊一体解决方案"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    // { fontSize: 'small', value: "AUTOSAR解决方案" },
                    // { fontSize: 'normal', value: "AUTOSAR解决方案" },
                    { fontSize: 'normal', value: "行泊一体解决方案" },
                ],
                content: [
                    { type: 'title', value: '行泊一体解决方案' },
                    { type: 'text', value: "行泊一体解决方案以 “智行慧停” 为核心理念，通过融合感知、决策与控制技术，将行车辅助与泊车功能深度整合。系统搭载多模态传感器（激光雷达、高清摄像头、毫米波雷达），构建全域环境感知网络，实时捕捉道路动态与车位信息，实现从高速巡航、城市跟车到自动泊入 / 驶出的全场景覆盖。\n\n算法层面，基于 AI 大模型优化路径规划，兼顾行车安全与泊车效率，支持跨楼层记忆泊车、异型车位识别等复杂场景。硬件端采用域控制器集成方案，减少线束冗余，降低能耗与故障率。云端平台提供数据闭环服务，通过 OTA 持续迭代策略，适配多样化用车需求。\n\n该方案可显著提升驾驶体验，缩短停车耗时 30% 以上，降低剐蹭风险，同时为车企节省 20%+ 研发成本，加速智能座舱向 “零操作” 目标迈进。" },
                    { type: 'text', value: '(1)高速领航：自动变道超车、匝道通行（支持高精地图/无图模式）。\n(2)记忆泊车：通过低速自动驾驶技术，实现在限定区域（园区、地上停车场及地下停车场等场景）的自主代客泊车功能。' },
                ]
            }
        }, {
            pageName: "车路云协同控制",
            dataId: "1-2-4",
            data: {
                routerList: ["产品", "智能驾驶系统", "车路云协同控制"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    // { fontSize: 'small', value: "AUTOSAR解决方案" },
                    // { fontSize: 'normal', value: "AUTOSAR解决方案" },
                    { fontSize: 'normal', value: "车路云协同控制" },
                ],
                content: [
                    { type: 'title', value: '车路云协同控制' },
                    { type: 'text', value: '车路云协同控制通过 “车端感知 + 路侧基建 + 云端算力” 三位一体架构，构建智能交通生态闭环。车端搭载高算力芯片与多传感器融合系统，实时采集车辆状态与周边环境数据；路侧部署毫米波雷达、边缘计算单元等设备，补全车端感知盲区，精准捕捉道路事件（如事故、施工）；云端依托 AI 算法与数字孪生技术，整合全域交通流信息，生成最优决策指令。\n\n三者通过 5G-V2X 低时延通信协议实时交互，实现超视距预警、协同式红绿灯优化、编队自动驾驶等场景应用。例如，路侧设备提前感知拥堵并上传云端，系统动态调整车端行驶路径；或在极端天气下，云端下发高精度地图辅助车辆避险。该方案有效提升通行效率 30% 以上，降低交通事故率，推动交通系统从 “单车智能” 迈向 “全局智控”，为智慧城市建设夯实底层架构。' },
                    { type: 'text', value: '(1)边缘计算单元（RSU）：支持C-V2X直连通信，红绿灯状态推送精度99%。\n(2)云端仿真平台：每日百万公里级场景测试，ODD场景库覆盖中国特有工况。' },
                ]
            }
        }, {
            pageName: "特种车辆解决方案",
            dataId: "1-2-5",
            data: {
                routerList: ["产品", "智能驾驶系统", "特种车辆解决方案"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    // { fontSize: 'small', value: "AUTOSAR解决方案" },
                    // { fontSize: 'normal', value: "AUTOSAR解决方案" },
                    { fontSize: 'normal', value: "特种车辆解决方案" },
                ],
                content: [
                    { type: 'title', value: '特种车辆解决方案' },
                    { type: 'text', value: '特种车辆解决方案以专业化、定制化为核心，针对工程抢险、医疗救护、警用消防等场景需求，构建 “硬件适配 + 智能管控 + 安全防护” 三位一体体系。硬件端集成模块化设备，如工程车搭载液压破拆系统、救护车配备负压隔离舱，满足特殊作业功能需求；智能管控层通过车载终端与指挥中心实时联动，支持任务调度、路径规划及远程监控；安全防护方案融合主动避障雷达、盲区监测与紧急制动系统，保障作业安全。\n\n系统兼容多通信协议，实现跨部门数据互通，配合 AI 算法优化资源调配效率。例如消防场景下，车辆可自动规划火情路线，同步传输现场影像至指挥中心；医疗转运中，车载生命体征监测数据实时上传医院。该方案显著提升特种作业响应速度与执行精度，助力行业高效履职与应急处置。' },
                    { type: 'text', value: 'DMS驾驶员监测系统、BSD商用车盲区监测、工程机械高精度作业辅助。' },
                ]
            }
        }, {
            pageName: "智能网联业务",
            dataId: "1-3-1",
            data: {
                routerList: ["产品", "智能网联平台", "智能网联业务"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    // { fontSize: 'small', value: "AUTOSAR解决方案" },
                    // { fontSize: 'normal', value: "AUTOSAR解决方案" },
                    { fontSize: 'normal', value: "智能网联业务" },
                ],
                content: [
                    { type: 'title', value: '互联车载设备T-box' },
                    { type: 'text', value: 'T-BOX，全称Telematics-BOX（车联网控制单元），指安装在汽车上用于控制跟踪汽车的嵌入式系统，主要由移动通信单元（4G/5G）、C-V2X通信单元、GNSS高精度定位模块、微处理器、车内总线控制器、存储器等部分组成。实现车辆与交通基础设施、云端平台的无缝通信，适配全球主流通信标准。' },
                    { type: 'title', value: 'OTA技术方案' },
                    { type: 'bigTitle', value: '产品优势' },
                    { type: "text", value: "（1）基于自主研发的大数据云计算平台，采用安全、稳定可靠的升级架构，实现高并发、可扩展。" },
                    { type: "text", value: "（2）支持千万级车载设备远程OTA接入，支持1W+并行下载。" },
                    { type: "text", value: "（3）支持整车各类ECU远程升级。" },
                    { type: "text", value: "（4） 支持国家商用密码算法(SM2、SM3、SM4)，实现远程升级信息安全防护。" },
                    { type: "text", value: "（5）具备断点续传、差分升级、程序回滚、安全加密等特点，保证OTA升级的准确性。" },
                    { type: "text", value: "（6）采用自研差分升级算法，并不断进行迭代优化，进而达到更小的差分包、更快的升级	 速度、更高的升级效率、更好的升级体验。" },
                    { type: "text", value: "（7）基于PKI/CA体系实现双向身份认证，搭建完善的信息安全体系。" },
                ]
            }
        }, {
            pageName: "信息安全体系",
            dataId: "1-3-2",
            data: {
                routerList: ["产品", "智能网联平台", "信息安全体系"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    // { fontSize: 'small', value: "AUTOSAR解决方案" },
                    // { fontSize: 'normal', value: "AUTOSAR解决方案" },
                    { fontSize: 'normal', value: "信息安全体系" },
                ],
                content: [
                    { type: 'title', value: '信息安全体系' },
                    { type: 'bigTitle', value: '产品优势' },
                    { type: "text", value: "(1)纵深防御架构：云、管、端三重防护体系" },
                    { type: "text", value: "(2)数据安全：采用SM9国密算法加密传输，支持欧盟GDPR/中国个保法合规要求" },
                    { type: "text", value: "(3)终端防护：T-box内置HSM安全芯片，实现安全启动+固件签名校验" },
                    { type: "text", value: "(4)攻击防御：部署AI驱动的入侵检测系统（IDS），日均拦截2,300万次异常访问" },
                    { type: "text", value: "(5)隐私保护：差分隐私技术实现用户轨迹数据匿名化处理，满足CCPA等隐私法规" },
                    { type: "text", value: "(6)应急响应：建立车联网安全实验室，具备0day漏洞24小时快速响应能力" },
                ]
            }
        }, {
            pageName: "全球化服务能力",
            dataId: "1-3-3",
            data: {
                routerList: ["产品", "智能网联平台", "全球化服务能力"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    // { fontSize: 'small', value: "AUTOSAR解决方案" },
                    // { fontSize: 'normal', value: "AUTOSAR解决方案" },
                    { fontSize: 'normal', value: "全球化服务能力" },
                ],
                content: [
                    { type: 'title', value: '全球化服务能力' },
                    { type: 'bigTitle', value: '产品优势' },
                    { type: "text", value: "(1)海外合规平台：适配数据隐私法规，支持50+国家TSP接入。" },
                    { type: "text", value: "(2)本地化运营：东南亚右舵车型适配、中东高温环境可靠性方案。" },
                ]
            }
        }, // 在 src/utils/utils.js 的 detailDataList 数组中添加以下内容：
        {
            pageName: "OTA",
            dataId: "tech-1",
            data: {
                routerList: ["产品", "智能技术方案", "OTA"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    { fontSize: 'normal', value: "OTA 远程升级方案" },
                ],
                content: [
                    { type: 'title', value: 'OTA 远程升级技术' },
                    { type: 'text', value: 'OTA（Over-the-Air Technology）即空中下载技术，是通过移动通信技术实现终端设备固件或软件远程升级的关键方案。八比特提供从云端管理平台到终端执行环境的全栈 OTA 解决方案。' },
                    { type: 'bigTitle', value: '产品优势' },
                    { type: 'text', value: '(1) 高效差分算法：采用自研差分技术，仅传输变更部分，大幅减少升级包体积，节省流量并缩短升级时长。' },
                    { type: 'text', value: '(2) 安全防护体系：基于 PKI/CA 体系实现双向身份认证，支持国密算法（SM2/SM3/SM4），确保升级包不被篡改。' },
                    { type: 'text', value: '(3) 高并发接入：支持千万级设备同时在线管理，具备万级并发下载处理能力。' },
                    { type: 'text', value: '(4) 完善的容错机制：支持断点续传、程序自动回滚及多分区备份，确保升级失败时设备仍能正常运行。' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '智能座舱系统更新、整车 ECU 固件升级、智能穿戴设备维护、工业物联网终端远程管理。' },
                ]
            }
        },{
            pageName: "软件定制化服务",
            dataId: "2-1-1",
            data: {
                routerList: ["服务", "定制服务", "软件定制化服务"],
                topImg: require("../assets/img/service1/service1.jpg"),
                topFont: [
                    // { fontSize: 'normal', value: "软件定制化服务" },
                ],
                content: [
                    {
                        type: 'spaceBetweenMore', value: '',
                        children1: [
                            { type: 'allImage', src: require("../assets/img/service1/定制服务.jpg") }
                        ],
                        children2: [
                            { type: 'title', value: '十年专注，只为一事——让软件精准匹配您的野心' },
                            { type: 'bigTitle', value: '从代码工匠到战略伙伴，我们重新定义软件定制的价值' },
                            { type: 'smallTitle', value: '【4000天深耕，让技术回归本质】' },
                            { type: 'text', value: '自2014年起，我们始终聚焦一件事：用代码解构商业逻辑。\n10年+技术沉淀，300+企业验证，拒绝“通用解决方案”的妥协，\n以外科手术式精准开发，为金融、医疗、智能制造等领域构建生长型数字系统。' },
                            { type: 'title', value: '为何选择“深度定制”？' },
                            { type: 'smallTitle', value: '• 您是否面临这些问题？' },
                            { type: 'text', value: '→ 通用软件功能冗余，核心需求却无法满足\n→ 现有系统迭代困难，拖慢业务创新速度\n→ 数据孤岛导致决策滞后，错失市场机会' },
                            { type: 'smallTitle', value: '——这不是技术问题，是战略问题。' },
                            { type: 'title', value: '我们的解决之道' },
                            { type: 'bigTitle', value: '10年淬炼的“3D开发体系”' },
                            { type: 'smallTitle', value: 'Define | 需求深挖' },
                            { type: 'text', value: '√ 15天深度调研：业务诊断+痛点地图+ROI推演\n√ 独创“双轨确认制”：技术可行性验证与商业价值验证同步' },
                            { type: 'smallTitle', value: 'Develop | 精准构建' },
                            { type: 'text', value: '√ 模块化开发：像拼装乐高一样自由组合功能\n√ 云原生架构：系统可随业务规模自动伸缩\n√ 安全双保险：等保三级基础+动态渗透测试' },
                            { type: 'smallTitle', value: 'Deliver | 长效共生' },
                            { type: 'text', value: '√ 交付不是终点：每月迭代建议报告+紧急BUG 15分钟响应\n√ “技术移植计划”：为您的团队配备定制系统操作DNA' },
                            { type: 'title', value: ' 客户选择我们的4个理由' },
                            { type: 'text', value: '✓ 更懂行业：医疗HIPAA合规/金融级加密/工业物联网协议预封装\n✓ 更快响应：30人专属技术中台，需求变更3工作日反馈方案\n✓ 更可持续：预留50个扩展接口，支持未来十年技术升级\n✓ 更省成本：比自建团队节省60%费用，比外包开发缩短40%工期' },
                        ],
                    },
                ]
            }
        }, {
            pageName: "智能网联汽车",
            dataId: "d-1-1",
            data: {
                routerList: ["智能汽车", "智能网联汽车"],
                topImg: require("../assets/img/home1/banner1-1.jpg"),
                topFont: [
                    // { fontSize: 'small', value: "AUTOSAR解决方案" },
                    // { fontSize: 'normal', value: "AUTOSAR解决方案" },
                    { fontSize: 'normal', value: "智能网联汽车" },
                ],
                content: [
                    { type: 'title', value: '智能网联汽车' },
                    { type: 'text', value: '八比特基于积累多年的嵌入式操作系统优化   技术、人机交互、机器视觉、以及语音和音   频技术，为汽车提供从操作系统开发到应用  定制，包括汽车信息娱乐系统、智能仪表盘、 集成驾驶舱和音频产品在内的整体智能座舱   系统解决方案和技术服务，为驾乘者提供丰   富、先进的智能驾驶体验。' },
                    { type: 'text', value: '八比特与Qualcomm、Renesas、TI、NXP、ST、 QNX、Intel、Baidu、SONY等全球领先的汽车 电子上游供应商紧密合作，为汽车OEM厂商和 Tier1企业提供完整的解决方案。凭借在Android、Linux、QNX等操作系统上的丰富研 发经验和积累，有效减少客户开发、调试和  验证工期，并加速提升智能网联汽车的品质  及用户体验，同时大大缩短产品上市时间。' },
                    {
                        type: 'twoImage', count: 2,
                        srcList: [
                            { name: null, src: require("../assets/img/industry/intenetwork1.png") },
                            { name: null, src: require("../assets/img/industry/intenetwork2.png") },]
                    },
                    {
                        type: 'text_flex',
                        children: [
                            { type: 'bigTitle', value: '智能座舱系统平台' },
                            { type: 'bigTitle', value: '智能车联系统平台' },
                        ]
                    },
                    {
                        type: 'text_flex',
                        children: [
                            { type: 'text', value: '提供不同平台化产品\n支持多硬件平台及多屏互动\n支持云服务\n5G通信 V2X车路协同\n优秀的多交互模式' },
                            { type: 'text', value: '智能通讯 V2X车路协同\n软件工程服务\n车载导航\n车联网安全' },
                        ]
                    },
                    {
                        type: 'text_flex',
                        children: [
                            { type: 'bigTitle', value: '智能车机' },
                            { type: 'bigTitle', value: '数字仪表' },
                        ]
                    },
                    {
                        type: 'text_flex',
                        children: [
                            { type: 'text', value: '车机硬件平台涉及市面大多数主流芯片\n丰富的前装经验\n能够集AR数据、渲染、交互三大引擎于一身' },
                            { type: 'text', value: '开机速度远高于普遍标准\n支持三方应用双开\n车载导航\n通过系统调优降低硬件成本' },
                        ]
                    },
                    {
                        type: 'text_flex',
                        children: [
                            { type: 'bigTitle', value: 'T-BOX' },
                        ]
                    },
                    {
                        type: 'text_flex',
                        children: [
                            { type: 'text', value: '高水准更稳定\n研发集成C-V2X、ETC功能的5G、V2X、BOX产品\n针对新能源汽车推出电池使用情况与电池健康安全维护功能' },
                        ]
                    },

                ]
            }
        }, {
            pageName: "智能座舱系统平台",
            dataId: "d-1-2",
            data: {
                routerList: ["智能汽车", "智能座舱系统平台"],
                topImg: require("../assets/img/industry/car.jpg"),
                topFont: [
                    // { fontSize: 'small', value: "车载通信解决方案" },
                    // { fontSize: 'normal', value: "车载通信解决方案" },
                    { fontSize: 'normal', value: "智能座舱系统平台" },
                ],
                content: [
                    { type: 'title', value: '智能座舱系统平台' },
                    { type: 'text', value: '八比特智能座舱系统平台，融合IVI、T-BOX、PSE、HUD、Digital Cluster、RSE等智能网联终端，致力于改善下一代智能网联汽车驾驶舱的用户体验，为车主提供更智能、更安全、更简单的汽车生活。' },
                    { type: 'text', value: '智能座舱系统平台集成语音识别功能，用户可根据自己的喜好进行个性化设置, 播放偏好的音乐，调整合适的空调温度、座椅角度，以及切换车机的主题风格等。同时打通双路音源，中控与副驾屏可分别收听不同音乐，并可以进行两屏间的音乐分享，视频资源可以从副屏分享到主屏，两屏进行同步播放，并且双屏用户均可进行视频播放，暂停，进度条调节等。' },
                    { type: 'image', src: require("../assets/img/industry/carbin.png") },
                    { type: 'image', src: require("../assets/img/industry/carbin2.png") }
                ]
            }
        }, {
            pageName: "智能车联系统平台",
            dataId: "d-1-3",
            data: {
                routerList: ["智能汽车", "智能车联系统平台"],
                topImg: require("../assets/img/industry/car.jpg"),
                topFont: [
                    // { fontSize: 'small', value: "车载通信解决方案" },
                    // { fontSize: 'normal', value: "车载通信解决方案" },
                    { fontSize: 'normal', value: "智能车联系统平台" },
                ],
                content: [
                    { type: 'title', value: '智能车联系统平台' },
                    { type: 'text', value: '八比特基于积累多年的物联网云端技术，结合智能座舱系统平台，开发出智能车联系统平台。通过T-BOX车载通信产品，建立车联网基础服务云平台，从而在云、管、端搭建一体化的智能车联系统平台，可快速适配对接第三方应用、平台、TSP，以及车厂OEM私有云联系统、呼叫中心服务，也可根据用户需求，深度定制应用，结合大数据分析，进一步赋能客户价值。' },
                    {
                        type: 'twoImage', count: 2,
                        srcList: [
                            { name: null, src: require("../assets/img/industry/network.png") },
                            { name: null, src: require("../assets/img/industry/network2.png") }]
                    },
                ]
            }
        }, {
            pageName: "智能车机",
            dataId: "d-1-4",
            data: {
                routerList: ["智能汽车", "智能车机"],
                topImg: require("../assets/img/industry/car.jpg"),
                topFont: [
                    // { fontSize: 'small', value: "车载通信解决方案" },
                    // { fontSize: 'normal', value: "车载通信解决方案" },
                    { fontSize: 'normal', value: "智能车机" },
                ],
                content: [
                    { type: 'title', value: '智能车机' },
                    { type: 'text', value: "八比特智能车机的硬件平台涉及NXP、Intel、Qualcomm、Renesas、TI等主流芯片，覆盖高、中、低端全系平台产品，软件平台基于Android、Linux、QNX三大系统，产品定位各种车型，并在8寸、9寸、10.1寸、10.4寸、12.3寸、17寸屏幕上具有大量前装经验，并对横屏、竖屏交互与多应用交互有着深度研究与探索。" },
                    { type: 'text', value: '智能车机的信息娱乐系统，基本功能包括车载语音助手、USB多媒体播放、蓝牙音乐、蓝牙电话、收音机、地图导航、设置、诊断、空调、方控、用户手册等，并可集成第三方应用程序，可以为客户实现Linux、Android系统下对汽车导航、信息、娱乐综合系统的深度定制。' },
                    {
                        type: 'twoImage', count: 2,
                        srcList: [
                            { name: null, src: require("../assets/img/industry/car2.png") },
                            { name: null, src: require("../assets/img/industry/car1.png") }]
                    },
                ]
            }
        }, {
            pageName: "T-Box",
            dataId: "d-1-5",
            data: {
                routerList: ["智能汽车", "T-Box"],
                topImg: require("../assets/img/industry/car.jpg"),
                topFont: [
                    // { fontSize: 'small', value: "车载通信解决方案" },
                    // { fontSize: 'normal', value: "车载通信解决方案" },
                    { fontSize: 'normal', value: "T-Box" },
                ],
                content: [
                    { type: 'title', value: 'T-Box' },
                    { type: 'text', value: "T-BOX产品是车联网必要入口和唯一通道。八比特基于多年开发经验，通过T-BOX产品赋能客户，给整车提供X-CALL、远程监控、诊断、控制、无线升级、网络防护、数据安全、全球高精度定位等功能，为客户深度打造整合、丰富、安全的智能网联体验。" },
                    {
                        type: 'threeImage', count: 3,
                        srcList: [
                            { name: null, src: require("../assets/img/industry/tbox2.png") },
                            { name: null, src: require("../assets/img/industry/tbox3.png") },
                            { name: null, src: require("../assets/img/industry/tbox5.jpg") },
                        ]
                    },
                ]
            }
        }, {
            pageName: "数字仪表",
            dataId: "d-1-6",
            data: {
                routerList: ["智能汽车", "数字仪表"],
                topImg: require("../assets/img/industry/car.jpg"),
                topFont: [
                    // { fontSize: 'small', value: "车载通信解决方案" },
                    // { fontSize: 'normal', value: "车载通信解决方案" },
                    { fontSize: 'normal', value: "数字仪表" },
                ],
                content: [
                    { type: 'title', value: '数字仪表' },
                    { type: 'text', value: "数字仪表是指将传统机械仪表盘替换成一整块液晶屏幕向驾驶者展示车辆行驶信息的设备，取消了传统的物理指针，全部通过电子屏幕展示。它的优点是不仅能传达给驾驶者传统机械仪表盘展示的车辆行驶速度、发动机转速、剩余油量等基本信息，还能使显示效果更加绚丽、实现个性化设置、显示内容更丰富，还提升了整车的科技感。" },
                    { type: 'text', value: '八比特数字仪表搭载高度定制化的QNX操作系统，针对汽车仪表特性裁剪内核，高于业内普遍标准的开机速度。支持QT、KANZI专业化图形引擎及设计工具，适配NXP i.MX6，i.MX8，Ti J6，Renesas R-CAR多个芯片平台，具备强大的图像处理和显示效果，具有HMI可配置、分辨率可适配的特点，并能够为客户提供专业的UI/UX设计，提升用户体验和驾驶安全。' },
                    { type: 'image', src: require("../assets/img/industry/instrument.png") },
                    { type: 'image', src: require("../assets/img/industry/instrument2.png") },
                ]
            }
        }, {
            pageName: "车载通信解决方案",
            dataId: "d-2-1",
            data: {
                routerList: ["产品", "服务", "车载通信解决方案"],
                topImg: require("../assets/img/industry/car.jpg"),
                topFont: [
                    // { fontSize: 'small', value: "车载通信解决方案" },
                    // { fontSize: 'normal', value: "车载通信解决方案" },
                    { fontSize: 'normal', value: "车载通信解决方案" },
                ],
                content: [
                    { type: 'title', value: '车载通信解决方案' },
                    { type: 'textImg_left', src: require("../assets/img/industry/message2.png"), value: '数字仪表是指将传统机械仪表盘替换成一整块液晶屏幕向驾驶者展示车辆行驶信息的设备，取消了传统的物理指针，全部通过电子屏幕展示。它的优点是不仅能传达给驾驶者传统机械仪表盘展示的车辆行驶速度、发动机转速、剩余油量等基本信息，还能使显示效果更加绚丽、实现个性化设置、显示内容更丰富，还提升了整车的科技感。\n\n八比特数字仪表搭载高度定制化的QNX操作系统，针对汽车仪表特性裁剪内核，高于业内普遍标准的开机速度。支持QT、KANZI专业化图形引擎及设计工具，适配NXP i.MX6，i.MX8，Ti J6，Renesas R-CAR多个芯片平台，具备强大的图像处理和显示效果，具有HMI可配置、分辨率可适配的特点，并能够为客户提供专业的UI/UX设计，提升用户体验和驾驶安全。' },
                    {
                        type: 'twoImage', count: 2,
                        srcList: [
                            { name: null, src: require("../assets/img/industry/message3.png") },
                            { name: null, src: require("../assets/img/industry/message.png") }]
                    },
                ]
            }
        }, {
            pageName: "智慧互联解决方案",
            dataId: "d-2-2",
            data: {
                routerList: ["产品", "服务", "智慧互联解决方案"],
                topImg: require("../assets/img/industry/car.jpg"),
                topFont: [
                    // { fontSize: 'small', value: "智慧互联解决方案" },
                    // { fontSize: 'normal', value: "智慧互联解决方案" },
                    { fontSize: 'normal', value: "智慧互联解决方案" },
                ],
                content: [
                    { type: 'title', value: '智慧互联解决方案' },
                    { type: 'textImg_left', src: require("../assets/img/industry/link.png"), value: '智慧互联解决方案，从用户角度出发，结合手机移动端，可以适配搭载多款智能车机，并为主流车厂提供了手车互联的解决方案。它构建了人与车之间的生态互联，将手机与车机轻松快捷连接，车主在驾驶中便可安全体验到手机端的所有应用服务和智能推送，给车主带来更安全，更便捷的全新互联网驾驶体验。\n\n除传统手机互联投屏方案外，还可提供数据共享方案，重新定义了人车互联的新玩法，覆盖多种场景，为用户量身定制，提供了如车载微信、导航通讯、天气股票、新闻资讯、音乐视频、FM情景、笑话百科、车辆设置等丰富的内容。解决方案可以快速实现，提供高品质的出行体验，相对完善的应用生态体系，并提供车厂OEM定制的车机应用。' },
                ]
            }
        }, {
            pageName: "智能交互解决方案",
            dataId: "d-2-3",
            data: {
                routerList: ["产品", "服务", "智能交互解决方案"],
                topImg: require("../assets/img/industry/car.jpg"),
                topFont: [
                    // { fontSize: 'small', value: "智能交互解决方案" },
                    // { fontSize: 'normal', value: "智能交互解决方案" },
                    { fontSize: 'normal', value: "智能交互解决方案" },
                ],
                content: [
                    { type: 'title', value: '智能交互解决方案' },
                    { type: 'textImg_left', src: require("../assets/img/industry/interaction5.jpg"), value: '智能交互解决方案，实现了人与车之间的“对话”功能。车主可通过系统，轻松把握车辆状态信息（车速、里程、当前位置、车辆保养信息等）、路况信息、定速巡航设置、蓝牙免提设置、空调及音响的设置。交互目的是当驾驶员在操作各项功能时尽量不影响其对驾驶本身的注意力。而传统的点、按、旋钮式的操作过于复杂会使驾驶员的视线离开路面，这也是语音与手势存在的逻辑基础。\n\n智能交互解决方案主要包括语音识别和手势识别。理想中的交互方式，不是某一种交互方式，而是多种交互方式的融合，为用户多场景的使用提供最优化的便利服务。' },
                    {
                        type: 'twoImage', count: 2,
                        srcList: [
                            { name: null, src: require("../assets/img/industry/interaction2.jpg") },
                            { name: null, src: require("../assets/img/industry/interaction3.jpg") }]
                    },
                ]
            }
        }, {
            pageName: "智能升级解决方案",
            dataId: "d-2-4",
            data: {
                routerList: ["产品", "服务", "智能升级解决方案"],
                topImg: require("../assets/img/industry/car.jpg"),
                topFont: [
                    // { fontSize: 'small', value: "智能升级解决方案" },
                    // { fontSize: 'normal', value: "智能升级解决方案" },
                    { fontSize: 'normal', value: "智能升级解决方案" },
                ],
                content: [
                    { type: 'title', value: '智能升级解决方案' },
                    { type: 'textImg_left', src: require("../assets/img/industry/interaction5.jpg"), value: '基于主机厂在平台发布的更新包，车辆可实现随时进行固件、车身控制系统、车载系统等系统远程升级，快速修复系统缺陷，有效降低售后服务成本。\n\n智能升级解决方案支持汽车以及各种智能物联网终端，支持多种架构的智能移动终端，如手机、平板、智能网联设备，通过OMA-DM标准认证，支持差分算法，使升级更加高效可靠，同时支持多分区，在实车MCU、ECU模块进行升级认证。采用高效开发合作模式，缩短开发周期，丰富的平台化部署项目经验，完美接入车厂全流程IT系统，全方位的升级安全防护机制，基于标准的认证、身份验证和加密，支持硬件安全加密，安全守卫OTA升级。' },
                    {
                        type: 'twoImage', count: 2,
                        srcList: [
                            { name: null, src: require("../assets/img/industry/interaction2.jpg") },
                            { name: null, src: require("../assets/img/industry/interaction3.jpg") }]
                    },
                ]
            }
        }, {
            pageName: "车载关键技术",
            dataId: "d-2-5",
            data: {
                routerList: ["产品", "服务", "车载关键技术"],
                topImg: require("../assets/img/industry/car.jpg"),
                topFont: [
                    // { fontSize: 'small', value: "车载关键技术" },
                    // { fontSize: 'normal', value: "车载关键技术" },
                    { fontSize: 'normal', value: "车载关键技术" },
                ],
                content: [
                    { type: 'title', value: '车载关键技术' },
                    { type: 'bigTitle', value: '手机互联' },
                    { type: 'textImg_left', src: require("../assets/img/industry/phone_connect1.png"), value: '手机互联技术构建了人与车之间的生态互联，将手机与车机轻松快捷连接，车主在驾驶中便可安全体验到手机端的所有应用服务和智能推送，给车主带来更安全，更便捷的全新互联网驾驶体验。拥有目前主流的各种智能网联汽车与手机互联的解决方案，可以根据客户需求，提供多种互联解决方案Android Auto、Carplay、Carlife、SmartLink。' },
                    { type: 'bigTitle', value: '操作系统性能和稳定性优化' },
                    { type: 'textImg_left', src: require("../assets/img/industry/system.png"), value: '拥有Qualcomm、TI、NXP、Renesas、ST等各个平台主流芯片的驱动开发能力，并根据客户需要进行灵活的定制。通过对Android/Linux操作系统的BSP、Kernel和Framework进行优化和调整，能够为客户智能网联汽车系统提供更好的性能和稳定性。同时通过对HMI Framework和显示算法的优化和调整，能够为客户提供更好的UI/UX操作体验。' },
                    { type: 'bigTitle', value: 'CAN协议栈和应用' },
                    { type: 'textImg_left', src: require("../assets/img/industry/can.png"), value: '经过多年在CAN协议开发方面的经验，具有对市面上成熟的CAN协议栈的集成和定制能力。CAN协议开发涉及Application layer、Physical Layer、Communication layer、Diagnostic（UDS or KWP2000）、OSEK NM、AutoSar NM等，以及具备完整CAN模组测试方案。' },
                    { type: 'bigTitle', value: 'MCU/ECU开发' },
                    { type: 'textImg_left', src: require("../assets/img/industry/mcu.jpg"), value: '具有基于AUTOSAR标准环境开发的经验，拥有NXP、Renesas、TI、CYPRESS、STM32、FUJITSU等主流芯片开发能力，能够结合客户具体需求，对MCU/ECU芯片进行定制开发。同时基于实时操作系统μCOS、FreeRTOS等，进行物联网系统定制开发能力。' },
                    { type: 'bigTitle', value: '语音识别' },
                    { type: 'textImg_left', src: require("../assets/img/industry/voice1.jpg"), value: '基于科大讯飞、思必驰、Nuance、Google、亚马逊等语音识别引擎，针对智能车载应用场景为用户提供语音免唤醒及语音控制汽车车窗、天窗、空调、蓝牙电话、多媒体音源等语音助手解决方案，可根据车厂/OEM需求，快速定制，跨系统平台，支持多国语言输入、随时打断/唤醒等。' },
                ]
            }
        }, {
            pageName: "关于我们",
            dataId: "3-1-1",
            data: {
                routerList: ["公司信息", "关于我们"],
                topImg: require("../assets/img/service1/new_bg.webp"),
                topFont: [
                    // { fontSize: 'normal', value: "关于我们" },
                    // { fontSize: 'small', value: "ABOUT US" },

                ],
                content: [
                    // { type: 'title', value: '公司简介' },
                    // 添加小标题1
                    { type: 'subtitle', value: '成为卓越的智能技术方案提供商' },
                    { type: 'text', value: '八比特科技有限公司创建于 2014 年，是一家专注于智能技术研发的创新型科技企业、国家高新技术企业、专精特新企业。目前旗下七家公司，分布于深圳、上海、大连、沈阳、重庆。公司基于“AI-Driven”智能驱动的战略导向，深耕智能汽车、智慧医疗、金融社保、智慧教育领域，为客户提供完整的智能技术解决方案和智能产品，涵盖企划、运营、研发、生产、评测、销售、维护各生态链环节。' },
                    // { type: 'text', value: '' },
                    { type: 'text', value: '产品与服务中，汽车智能座舱、汽车智能驾驶、汽车电源控制、无人机智能飞控、彩超图形图像、磁共振成像、血液细胞分析仪、社保信息管理系统、医院信息管理系统是主要产品，多年来各系统持续运转，实战中在精确度、高效能、可靠性、稳定性、可维护性等方面得到严格验证，持续赢得了客户满意与认同。' },
                    { type: 'text', value: '科技引领未来，创新点亮生活。公司以探索未来科技，创新智慧生活为愿景，以成为卓越的智能技术方案提供商为使命，持续产品迭代和优化，用匠心精神赋能科技发展，致力于与全球合作伙伴在汽车产业链、医疗产业链、政务服务产业链、教育产业链中协同发展共创未来。' },
                    // 添加小标题2
                    { type: 'subtitle', value: '八比特名字由来' },
                    { type: 'text', value: '八比特是计算机运算的最小存储单元，即一个字节，从一个字节开始存储了整个计算世界，取其求真、务实之意，寓意着科技发展始于基础，继而开创未来。' },
                    // 添加小标题3
                    { type: 'subtitle', value: '发展历程' },
                    { type: 'text', value: '• 2014 年，成立大连八比特科技有限公司' },
                    { type: 'text', value: '• 2014 年，成立深圳八比特信息技术有限公司' },
                    { type: 'text', value: '• 2015 年，成立重庆八比特科技有限公司' },
                    { type: 'text', value: '• 2016 年，成立上海八比信息技术有限公司' },
                    { type: 'text', value: '• 2020 年，成立八比智联（沈阳）科技有限公司' },
                    { type: 'text', value: '• 2020 年，成立八比智行（大连）科技有限公司' },
                    { type: 'text', value: '• 2025 年，成立深圳八比特教育科技有限公司' },
                    // { type: 'title', value: '产品优势' },
                    // { type: 'text', value: '自2014年，八比特基于积累多年的嵌入式操作系统优化技术、人机交互、机器视觉、以及语音和音频技术，为汽车提供从操作系统开发到应用定制，包括汽车信息娱乐系统、智能仪表盘、集成驾驶舱和音频产品在内的整体智能座舱软件解决方案和技术服务，为驾乘者提供丰富、先进的智能驾驶体验。八比特与Qualcomm、Renesas、TI、NXP、ST、QNX、Intel、Baidu、SONY等全球领先的汽车电子上游供应商紧密合作，为汽车OEM厂商和Tier1提供完整的解决方案、工具和服务。凭借在Android、Linux、QNX等操作系统上的丰富研发经验，可以有效减少客户开发、调试和验证工期，并加速提升智能网联汽车的品质及用户体验，同时大大缩短产品上市时间。' },

                ]
            }
        }, {
            pageName: "发展历程",
            dataId: "3-1-2",
            data: {
                routerList: ["公司信息", "发展历程"],
                topImg: require("../assets/img/service1/new_bg.webp"),
                topFont: [
                    // { fontSize: 'normal', value: "发展历程" },
                    // { fontSize: 'small', value: "发展历程" },

                ],
                content: [
                    { type: 'title', value: '发展历程' },
                    { type: 'bigTitle', value: '2014年' },
                    { type: 'text', value: '03月 创建大连八比特科技有限公司\n05月 成立八比特科技沈阳分公司\n12月 成立深圳八比特信息技术有限公司' },
                    { type: 'bigTitle', value: '2015年' },
                    { type: 'text', value: '11月 成立重庆八比特科技有限公司' },
                    { type: 'bigTitle', value: '2016年' },
                    { type: 'text', value: '02月 成立上海八比信息技术有限公司' },
                    { type: 'bigTitle', value: '2017年' },
                    { type: 'text', value: '04月 车载业务与航盛电子开始深度合作，集中在智能座舱领域，产品面向国内市场' },
                    { type: 'bigTitle', value: '2018年' },
                    { type: 'text', value: '08月 八比特科技获得大连市第四届科技创业大赛二等奖\n10月 八比特科技造访杭州，深度考察阿里巴巴\n10月 八比特科技走进杭州\n11月 八比特公司参加中国创新创业大赛\n12月 大连市科技局领导莅临八比特\n12月 大连理工大学到八比特科技参观' },
                    { type: 'bigTitle', value: '2019年' },
                    { type: 'text', value: '01月 第四届大连市科技创新创业大赛圆满收官\n02月 五菱Almaz上市\n05月 日本AT Works株式会社东京本社造访八比特科技\n09月 电动名爵EZS泰国上市\n10月 2020款宝骏530成功上市\n10月 八比特科技阔别弘泰大厦，喜迁海事科技大厦' },
                    { type: 'bigTitle', value: '2020年' },
                    { type: 'text', value: '07月 2020年首届软件定义汽车高峰论坛圆满落幕\n07月 成立八比智联（沈阳）科技有限公司\n12月 成立八比智行（大连）科技有限公司' },
                    { type: 'bigTitle', value: '2021年' },
                    { type: 'text', value: '07月 八比特科技成功亮相2021中国国际数字和软件服务交易会' },
                    { type: 'bigTitle', value: '2022年' },
                    { type: 'text', value: '06月 助力智能汽车快速发展，华为代表团到访八比特科技调研\n06月 八比特科技出席“海聚高新 创新未来”系列活动之第三场活动' },
                    { type: 'bigTitle', value: '2023年' },
                    { type: 'text', value: '03月 八比特科技当选大连市车联网产业创新联盟第二届理事单位 \n04月 江西交通职业技术学院在八比特科技设立校外实训基地与就业实践基地\n11月 八比特科技车载项目获 “数字辽宁 智造强省” 专项资金支持\n12月 八比智联（沈阳）科技有限公司成功获得 “国家高新技术企业” 认定\n12月 八比特科技荣获2023年辽宁省 “专精特新” 中小企业称号' },
                    { type: 'bigTitle', value: '2024年' },
                    { type: 'text', value: '01月 八比智联、八比智行成功入选辽宁省“雏鹰企业”\n05月 八比特科技荣获2024年车联网成长企业称号\n11月 重庆八比特获评"国家高新技术企业"\n12月 八比特旗下大连八比特科技有限公司、八比智行（大连）科技有限公司再获国家高新技术企业认定\n12月 大连八比特科技有限公司成功当选为第三届理事会的副理事长单位 '},
                    { type: 'bigTitle', value: '2025年' },
                    { type: 'text', value: "01月 成立深圳八比特教育科技有限公司" },
                ]
            }
        }, {
            pageName: "主要合作企业及品牌",
            dataId: "3-1-3",
            data: {
                routerList: ["合作与联系", "主要合作企业及品牌"],
                topImg: require("../assets/img/service1/new_bg.webp"),
                topFont: [
                    // { fontSize: 'normal', value: "合作客户" },
                    // { fontSize: 'small', value: "合作客户" },

                ],
                content: [
                    { type: 'title', value: '合作品牌' },
                    {
                        type: 'fourImage', count: 4,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/kh/kh1.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/kh/kh2.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/kh/kh3.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/kh/kh4.jpg") },]

                    }, {
                        type: 'fourImage', count: 4,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/kh/kh5.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/kh/kh6.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/kh/kh7.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/kh/kh8.jpg") },]

                    }, {
                        type: 'fourImage', count: 4,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/kh/kh9.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/kh/kh10.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/kh/kh11.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/kh/kh12.jpg") },]
                    }, {
                        type: 'fourImage', count: 4,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/kh/kh13.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/kh/kh14.jpg") },]
                    },
                    { type: 'bigTitle', value: '' },
                    { type: 'bigTitle', value: '' },
                    { type: 'title', value: '合作企业' },
                    {
                        type: 'fourImage', count: 4,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/hb/hb1.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb2.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb3.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb4.jpg") },]
                    }, {
                        type: 'fourImage', count: 4,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/hb/hb.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb6.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb7.png") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb8.jpg") },]

                    }, {
                        type: 'fourImage', count: 4,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/hb/hb9.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb10.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb11.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb12.jpg") },]
                    }, {
                        type: 'fourImage', count: 4,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/hb/hb13.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb14.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb15.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb16.jpg") },]
                    }, {
                        type: 'fourImage', count: 4,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/hb/hb17.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb18.jpg") },]
                    },
                ]
            }
        }, {
            pageName: "合作伙伴",
            dataId: "3-1-4",
            data: {
                routerList: ["合作与联系", "合作伙伴"],
                topImg: require("../assets/img/service1/new_bg.webp"),
                topFont: [
                    // { fontSize: 'normal', value: "合作伙伴" },
                    // { fontSize: 'small', value: "合作伙伴" },

                ],
                content: [
                    { type: 'title', value: '合作伙伴' },
                    {
                        type: 'fourImage', count: 4,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/hb/hb1.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb2.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb3.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb4.jpg") },]
                    }, {
                        type: 'fourImage', count: 4,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/hb/hb.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb6.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb7.png") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb8.jpg") },]

                    }, {
                        type: 'fourImage', count: 4,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/hb/hb9.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb10.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb11.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb12.jpg") },]
                    }, {
                        type: 'fourImage', count: 4,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/hb/hb13.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb14.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb15.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb16.jpg") },]
                    }, {
                        type: 'fourImage', count: 4,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/hb/hb17.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/hb/hb18.jpg") },]
                    },
                ]
            }
        }, {
        pageName: "联系我们",
        dataId: "3-1-5",
        data: {
            routerList: ["合作与联系", "联系我们"],
            topImg: require("../assets/img/service1/new_bg.webp"),
            topFont: [],
            content: [
                { type: 'title', value: '官方邮箱', layout: 'center' },
                { type: 'text', value: 'service@cn8bit.com', layout: 'center' },

                { type: 'title', value: '联系电话', margin: '40px 0 15px 0', layout: 'center' },
                { type: 'text', value: '0411-84573211\n0411-84457557', layout: 'center' },

                { type: 'title', value: '官方微信', margin: '40px 0 15px 0', layout: 'center' },
                { type: 'image', src: require("../assets/img/aboutUs/8bit_code_1.jpg"), layout: 'center', width: '130px', name: '八比特科技' },
                { type: 'image', src: require("../assets/img/aboutUs/8bit_code_2.jpg"),layout: 'center', width: '130px', name: '深圳八比特科技' },

                { type: 'title', value: '地址', margin: '40px 0 15px 0', layout: 'center' },
                { type: 'text', value: '深圳：南山区南海大道3003号阳光华艺大厦A座4层\n大连：高新园区黄浦路523号海事科技大厦A座21层\n上海：徐汇区虹漕路421号虹漕园62幢301室\n重庆：两江新区星光大道90号土星A2座13层\n沈阳：浑南区国际软件园E01座14层', layout: 'center' },

                { type: 'title', value: '商务合作', margin: '40px 0 15px 0', layout: 'center' },
                { type: 'image', src: require("../assets/img/aboutUs/code_2.jpg"), layout: 'center',  width: '130px', name: '备注：商务合作' },
            ]
        }
    }, {
            pageName: "加入我们",
            dataId: "3-1-6feiqi",
            data: {
                routerList: ["公司信息", "加入我们"],
                topImg: require("../assets/img/aboutUs/company1.png"),
                topFont: [
                    // { fontSize: 'normal', value: "加入我们" },
                    // { fontSize: 'small', value: "加入我们" },

                ],
                content: [
                    {
                        type: 'spaceBetweenMore', value: '', layout1: "normal", layout2: "normal",
                        children1: [
                            { type: 'allImage', src: require("../assets/img/service1/定制服务.jpg") }
                        ],
                        children2: [
                            { type: 'title', value: '十年专注，只为一事——让软件精准匹配您的野心' },
                            { type: 'bigTitle', value: '从代码工匠到战略伙伴，我们重新定义软件定制的价值' },
                            { type: 'smallTitle', value: '【4000天深耕，让技术回归本质】' },
                            { type: 'text', value: '自2014年起，我们始终聚焦一件事：用代码解构商业逻辑。\n10年+技术沉淀，300+企业验证，拒绝“通用解决方案”的妥协，\n以外科手术式精准开发，为金融、医疗、智能制造等领域构建生长型数字系统。' },
                            { type: 'title', value: '为何选择“深度定制”？' },
                            { type: 'smallTitle', value: '• 您是否面临这些问题？' },
                            { type: 'text', value: '→ 通用软件功能冗余，核心需求却无法满足\n→ 现有系统迭代困难，拖慢业务创新速度\n→ 数据孤岛导致决策滞后，错失市场机会' },
                            { type: 'smallTitle', value: '——这不是技术问题，是战略问题。' },
                            { type: 'title', value: '我们的解决之道' },
                            { type: 'bigTitle', value: '10年淬炼的“3D开发体系”' },
                            { type: 'smallTitle', value: 'Define | 需求深挖' },
                            { type: 'text', value: '√ 15天深度调研：业务诊断+痛点地图+ROI推演\n√ 独创“双轨确认制”：技术可行性验证与商业价值验证同步' },
                            { type: 'smallTitle', value: 'Develop | 精准构建' },
                            { type: 'text', value: '√ 模块化开发：像拼装乐高一样自由组合功能\n√ 云原生架构：系统可随业务规模自动伸缩\n√ 安全双保险：等保三级基础+动态渗透测试' },
                            { type: 'smallTitle', value: 'Deliver | 长效共生' },
                            { type: 'text', value: '√ 交付不是终点：每月迭代建议报告+紧急BUG 15分钟响应\n√ “技术移植计划”：为您的团队配备定制系统操作DNA' },
                            { type: 'title', value: ' 客户选择我们的4个理由' },
                            { type: 'text', value: '✓ 更懂行业：医疗HIPAA合规/金融级加密/工业物联网协议预封装\n✓ 更快响应：30人专属技术中台，需求变更3工作日反馈方案\n✓ 更可持续：预留50个扩展接口，支持未来十年技术升级\n✓ 更省成本：比自建团队节省60%费用，比外包开发缩短40%工期' },
                        ],
                    },
                    // { type: 'bigTitle', value: 'UI设计岗应届实习生' },
                    // { type: 'text', value: '一、岗位内容：\n1. 负责独立设计各种类型的UI界面，包括但不限于Web、App、小程序、PC等界面的设计；\n2. 研究最新用户体验设计趋势和技术，持续推进产品设计优化，提升用户满意度；\n3. 制定企业视觉设计规范，并对现有设计进行改进和完善。\n\n二、任职要求：\n1. 学历不限，计算机软件/平面设计/交互设计/视觉传达等相关专业背景；\n2. 精通Sketch、Photoshop、Illustrator等设计软件，具有深厚的设计功底，熟悉最新的UI设计规范；\n3. 有较强的自我驱动力和学习意愿，关注国内外最新设计动态和流行趋势；\n4. 具备良好的沟通协调能力和团队协作精神，能够适应快速变化的环境。\n5.具有Java前端开发基础优先考虑\n\n三、实习时长\n实习期不可少于两个月，表现优异者，实习结束毕业后可申请转正。\n工作地点：大连高新园区' },
                ]
            }
        }, {
            pageName: "加入我们",
            dataId: "3-1-6old",
            data: {
                routerList: ["公司简介", "加入我们"],
                topImg: require("../assets/img/service1/new_bg.webp"),
                topFont: [
                    // { fontSize: 'normal', value: "加入我们" },
                    // { fontSize: 'small', value: "加入我们" },
                ],
                content: [
                    { type: "firstTitle", value: "汇聚英才 共赴新程", layout: "center" },
                    { type: "Title", value: "我们坚信，独特的品质能将卓越个体凝聚。", layout: "center", margin: '0 0 100px 0' },
                    // {
                    //     type: 'spaceBetweenMore', value: '',layout:'flex-center', layout1: "flex-start", layout2: "flex-end",
                    //     width1: "60%",
                    //     children1: [
                    //         { type: 'image', src: require("../assets/img/aboutUs/workSpace/evn_five.jpg") }
                    //     ],
                    //     children2: [
                    //         { type: 'bigTitle', value: '汇聚英才 共赴新程' },
                    //         { type: 'text', value: '我们坚信，独特的品质能将卓越个体凝聚。' },
                    //     ],
                    // },
                    {
                        type: 'spaceBetweenMore', value: '', layout1: "flex-start", layout2: "flex-end",
                        width1: "60%", margin: '0 0 150px 0',
                        children1: [
                            { type: 'bigTitle', value: '勇于开拓 突破边界', margin: '0 0 20px 0' },
                            { type: 'text', value: '创新源于无畏的探索与细微的积累。我们怀揣对未知的热忱，不惧新想法带来的挑战，敢于踏入无人之境。在技术浪潮中，以开拓精神引领前行，用创新笔触描绘未来蓝图，力求以前沿科技重塑行业格局。' },

                        ],
                        children2: [
                            { type: 'image', src: require("../assets/img/aboutUs/aboutUs1.jpg") }
                        ],
                    },
                    {
                        type: 'spaceBetweenMore', value: '', layout1: "flex-start", layout2: "flex-end",
                        width1: "60%", margin: '0 0 150px 0',
                        children1: [
                            { type: 'image', src: require("../assets/img/aboutUs/aboutUs2.jpg") }
                        ],
                        children2: [
                            { type: 'bigTitle', value: '笃信科学 探求本真', margin: '0 0 20px 0' },
                            { type: 'text', value: '秉持科学精神，倡导自由且严谨的探索氛围。在知识的殿堂里，摒弃等级与偏见，以开放的姿态交流碰撞。我们不迷信权威，不依赖过往经验，只尊崇事实与真理，在科学的道路上不断深耕，挖掘事物本质，让真知驱动发展。' },
                        ],
                    },
                    {
                        type: 'spaceBetweenMore', value: '', layout1: "flex-start", layout2: "flex-end",
                        width1: "60%", margin: '0 0 150px 0',
                        children1: [
                            { type: 'bigTitle', value: '好学奋进 精进不休', margin: '0 0 20px 0' },
                            { type: 'text', value: '深知成功需汗水浇筑，天赋不过是锦上添花。我们以好学为帆，以勤奋为桨，在知识的海洋中持续远航。每一位伙伴都如孜孜不倦的求学者，在各自领域精研深耕，以专业实力铸就坚实阶梯，稳步迈向卓越。' },

                        ],
                        children2: [
                            { type: 'image', src: require("../assets/img/aboutUs/aboutUs3.jpg") }
                        ],
                    },
                    {
                        type: 'spaceBetweenMore', value: '', layout1: "flex-start", layout2: "flex-end",
                        width1: "60%", margin: '0 0 150px 0',
                        children1: [
                            { type: 'image', src: require("../assets/img/aboutUs/aboutUs4(1).jpg") }
                        ],
                        children2: [
                            { type: 'bigTitle', value: '携手共进 谦逊致远', margin: '0 0 20px 0' },
                            { type: 'text', value: '过往荣耀皆为序章，新的朝阳每天都在升起。我们珍视团队中每一份独特才华，明白个体的光芒汇聚才能照亮前行之路。秉持谦逊态度，相互学习、彼此支持，携手并肩在新征程上稳步迈进，共同书写更辉煌的篇章。' },
                        ],
                    },
                    // { type: 'bigTitle', value: 'UI设计岗应届实习生' },
                    // { type: 'text', value: '一、岗位内容：\n1. 负责独立设计各种类型的UI界面，包括但不限于Web、App、小程序、PC等界面的设计；\n2. 研究最新用户体验设计趋势和技术，持续推进产品设计优化，提升用户满意度；\n3. 制定企业视觉设计规范，并对现有设计进行改进和完善。\n\n二、任职要求：\n1. 学历不限，计算机软件/平面设计/交互设计/视觉传达等相关专业背景；\n2. 精通Sketch、Photoshop、Illustrator等设计软件，具有深厚的设计功底，熟悉最新的UI设计规范；\n3. 有较强的自我驱动力和学习意愿，关注国内外最新设计动态和流行趋势；\n4. 具备良好的沟通协调能力和团队协作精神，能够适应快速变化的环境。\n5.具有Java前端开发基础优先考虑\n\n三、实习时长\n实习期不可少于两个月，表现优异者，实习结束毕业后可申请转正。\n工作地点：大连高新园区' },
                ]
            }
        },
        {
            pageName: "加入我们",
            dataId: "3-1-6",
            data: {
                routerList: ["公司信息", "加入我们"],
                topImg: require("../assets/img/service1/new_bg.webp"),
                topFont: [],
                content: [
                    // ========== 招聘岗位信息（放在最前面） ==========
                    { type: "firstTitle", value: "热招岗位", layout: "center", margin: '0 0 30px 0' },
                    { type: "Title", value: "加入我们，一起创造未来", layout: "center", margin: '0 0 50px 0' },

                    // 岗位1
                    { type: 'bigTitle', value: '初级嵌入式软件开发工程师', margin: '20px 0 15px 0' },
                    {
                        type: 'text',
                        value: '一、工作内容\n' +
                            '1、参与嵌入式软件的设计、开发与维护，确保项目按时交付。\n' +
                            '2、参与系统模块的测试，与团队协作确保软件质量。\n\n' +
                            '二、任职要求\n' +
                            '1、熟悉/精通C和C++，或其他编程语言，具备良好的编程习惯。\n' +
                            '2、计算机、通信、电气/自动化、机械等专业统招本科或以上学历。\n' +
                            '3、逻辑思维能力强，具有团队合作精神，学习能力强，有责任感，能够有效沟通并攻克技术难题。\n\n' +
                            '工作地点：大连高新园区'
                    },

                    // 岗位2
                    { type: 'bigTitle', value: '嵌入式应届实习生', margin: '40px 0 15px 0' },
                    {
                        type: 'text',
                        value: '一、工作内容\n' +
                            '1、参与嵌入式软件的设计、开发与维护，确保项目按时交付。\n' +
                            '2、参与系统模块的测试，与团队协作确保软件质量。\n\n' +
                            '二、任职要求\n' +
                            '1、熟悉/精通C和C++，或其他编程语言，具备良好的编程习惯。\n' +
                            '2、不限专业，统招本科及以上学历应届毕业生。\n' +
                            '3、逻辑思维能力强，具有团队合作精神，学习能力强，有责任感，能够有效沟通并攻克技术难题。\n\n' +
                            '三、实习时长\n' +
                            '实习期不可少于两个月，表现优异者，实习结束毕业后可申请转正。\n\n' +
                            '工作地点：大连高新园区'
                    },

                    // 简历投递方式
                    { type: 'bigTitle', value: '简历投递', margin: '50px 0 20px 0' },
                    { type: 'text', value: '请将简历发送至：service@cn8bit.com\n邮件标题格式：应聘岗位 + 姓名 + 毕业院校' },

                    // ========== 分割线（以下保留原企业文化内容） ==========
                    { type: "firstTitle", value: "汇聚英才 共赴新程", layout: "center", margin: '80px 0 30px 0' },
                    { type: "Title", value: "我们坚信，独特的品质能将卓越个体凝聚。", layout: "center", margin: '0 0 50px 0' },

                    {
                        type: 'spaceBetweenMore', value: '', layout1: "flex-start", layout2: "flex-end",
                        width1: "60%", margin: '0 0 150px 0',
                        children1: [
                            { type: 'bigTitle', value: '勇于开拓 突破边界', margin: '0 0 20px 0' },
                            { type: 'text', value: '创新源于无畏的探索与细微的积累。我们怀揣对未知的热忱，不惧新想法带来的挑战，敢于踏入无人之境。在技术浪潮中，以开拓精神引领前行，用创新笔触描绘未来蓝图，力求以前沿科技重塑行业格局。' },
                        ],
                        children2: [
                            { type: 'image', src: require("../assets/img/aboutUs/aboutUs1.jpg"), layout: 'center', width: '100%' }
                        ],
                    },
                    {
                        type: 'spaceBetweenMore', value: '', layout1: "flex-start", layout2: "flex-end",
                        width1: "60%", margin: '0 0 150px 0',
                        children1: [
                            { type: 'image', src: require("../assets/img/aboutUs/aboutUs2.jpg"), layout: 'center', width: '100%' }
                        ],
                        children2: [
                            { type: 'bigTitle', value: '笃信科学 探求本真', margin: '0 0 20px 0' },
                            { type: 'text', value: '秉持科学精神，倡导自由且严谨的探索氛围。在知识的殿堂里，摒弃等级与偏见，以开放的姿态交流碰撞。我们不迷信权威，不依赖过往经验，只尊崇事实与真理，在科学的道路上不断深耕，挖掘事物本质，让真知驱动发展。' },
                        ],
                    },
                    {
                        type: 'spaceBetweenMore', value: '', layout1: "flex-start", layout2: "flex-end",
                        width1: "60%", margin: '0 0 150px 0',
                        children1: [
                            { type: 'bigTitle', value: '好学奋进 精进不休', margin: '0 0 20px 0' },
                            { type: 'text', value: '深知成功需汗水浇筑，天赋不过是锦上添花。我们以好学为帆，以勤奋为桨，在知识的海洋中持续远航。每一位伙伴都如孜孜不倦的求学者，在各自领域精研深耕，以专业实力铸就坚实阶梯，稳步迈向卓越。' },
                        ],
                        children2: [
                            { type: 'image', src: require("../assets/img/aboutUs/aboutUs3.jpg"), layout: 'center', width: '100%' }
                        ],
                    },
                    {
                        type: 'spaceBetweenMore', value: '', layout1: "flex-start", layout2: "flex-end",
                        width1: "60%", margin: '0 0 150px 0',
                        children1: [
                            { type: 'image', src: require("../assets/img/aboutUs/aboutUs4(1).jpg"), layout: 'center', width: '100%' }
                        ],
                        children2: [
                            { type: 'bigTitle', value: '携手共进 谦逊致远', margin: '0 0 20px 0' },
                            { type: 'text', value: '过往荣耀皆为序章，新的朝阳每天都在升起。我们珍视团队中每一份独特才华，明白个体的光芒汇聚才能照亮前行之路。秉持谦逊态度，相互学习、彼此支持，携手并肩在新征程上稳步迈进，共同书写更辉煌的篇章。' },
                        ],
                    },
                ]
            }
        },{
            pageName: "工作环境",
            dataId: "d-3-1",
            data: {
                routerList: ["加入我们", "工作环境"],
                topImg: require("../assets/img/service1/new_bg.webp"),
                topFont: [
                    // { fontSize: 'normal', value: "工作环境" },
                    // { fontSize: 'small', value: "工作环境" },

                ],
                content: [
                    { type: 'title', value: '工作环境' },
                    {
                        type: 'threeImage', count: 3,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/workSpace/evn_one.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/workSpace/evn_two.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/workSpace/evn_three.jpg") },]
                    }, {
                        type: 'threeImage', count: 3,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/workSpace/evn_four.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/workSpace/evn_five.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/workSpace/evn_six.jpg") },]

                    }]
            }
        }, {
            pageName: "文化活动",
            dataId: "d-3-2",
            data: {
                routerList: ["加入我们", "文化活动"],
                topImg: require("../assets/img/service1/new_bg.webp"),
                topFont: [
                    // { fontSize: 'normal', value: "文化活动" },
                    // { fontSize: 'small', value: "文化活动" },

                ],
                content: [

                    { type: 'title', value: '文化活动' },
                    {
                        type: 'threeImage', count: 3,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/activity/activity_four.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/activity/activity_one.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/activity/activity_two.jpg") },]
                    },
                    {
                        type: 'threeImage', count: 3,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/activity/activity_five.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/activity/activity_eight.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/activity/activity_seven.jpg") },]
                    },
                    {
                        type: 'threeImage', count: 3,
                        srcList: [
                            { name: null, src: require("../assets/img/aboutUs/activity/activity_nine.jpg") },
                            { name: null, src: require("../assets/img/aboutUs/activity/activity_eleven.jpg") },]
                    }
                ]
            }
        }, {
            pageName: "专属福利",
            dataId: "d-3-3",
            data: {
                routerList: ["加入我们", "专属福利"],
                topImg: require("../assets/img/service1/new_bg.webp"),
                topFont: [
                    // { fontSize: 'normal', value: "专属福利" },
                    // { fontSize: 'small', value: "专属福利" },

                ],
                content: [
                    { type: 'title', value: '专属福利' },
                    {
                        type: 'text_flex',
                        children: [
                            { type: 'bigTitle', value: '衣食住行，无需烦忧' },
                            { type: 'bigTitle', value: '您的风险，由我防护' },
                        ]
                    },
                    {
                        type: 'text_flex',
                        children: [
                            { type: 'text', value: '公司周边、小吃齐全，加班报销车费并有加班费， 吃饱喝足才能干劲十足' },
                            { type: 'text', value: '五险一金，健全制度给你最大保障' },
                        ]
                    },
                    {
                        type: 'text_flex',
                        children: [
                            { type: 'bigTitle', value: '您的健康，由我守护' },
                            { type: 'bigTitle', value: '重要时刻，有我陪伴' },
                        ]
                    },
                    {
                        type: 'text_flex',
                        children: [
                            { type: 'text', value: '免费体检、样样齐全，为你的健康保驾护航' },
                            { type: 'text', value: '生日蛋糕、生日礼物，见证你的更多重要时刻' },
                        ]
                    },
                    {
                        type: 'text_flex',
                        children: [
                            { type: 'bigTitle', value: '游戏活动，丰富多彩' },
                            { type: 'bigTitle', value: '各类假期，应有尽有' },
                        ]
                    },
                    {
                        type: 'text_flex',
                        children: [
                            { type: 'text', value: '生活不只眼前的工作还有精彩的团建，来结识更多有趣的八比特人吧' },
                            { type: 'text', value: '法定假期、福利年假，让你劳逸结合，充分休息' },
                        ]
                    },
                ]
            }
        }, {
            pageName: "诚聘英才",
            dataId: "d-3-4feiqi",
            data: {
                routerList: ["加入我们", "诚聘英才"],
                topImg: require("../assets/img/service1/new_bg.webp"),
                topFont: [
                    // { fontSize: 'normal', value: "诚聘英才" },
                    // { fontSize: 'small', value: "诚聘英才" },

                ],
                content: [
                    { type: 'title', value: '诚聘英才' },
                    {
                        type: 'text_flex',
                        children: [
                            { type: 'bigTitle', value: '初级嵌入式软件开发工程师' },
                            { type: 'bigTitle', value: '嵌入式应届实习生' },
                        ]
                    },
                    {
                        type: 'text_flex',
                        children: [
                            { type: 'text', value: '一 、工作内容\n1、参与嵌入式软件的设计、开发与维护，确保项目按时交付。\n2、参与系统模块的测试，与团队协作确保软件质量。\n\n二、任职要求\n1、熟悉/精通C和C++，具备良好的编程习惯。\n2、不限专业，统招本科及以上学历应届毕业生。\n3、逻辑思维能力强，具有团队合作精神，学习能力强，有责任感，能够有效沟通并攻克技术难题。\n\n三、实习时长\n实习期不可少于两个月，表现优异者，实习结束毕业后可申请转正。\n工作地点：大连高新园区' },
                            { type: 'text', value: '一 、工作内容\n1、参与嵌入式软件的设计、开发与维护，确保项目按时交付。\n2、参与系统模块的测试，与团队协作确保软件质量。\n\n二、任职要求\n1、熟悉/精通C和C++，或其他编程语言，具备良好的编程习惯。\n2、计算机、通信、电气/自动化、机械等专业统招本科或以上学历。\n3、逻辑思维能力强，具有团队合作精神，学习能力强，有责任感，能够有效沟通并攻克技术难题。' },
                        ]
                    },
                ]
            }
        }, {
            pageName: "诚聘英才",
            dataId: "d-3-4",
            data: {
                routerList: ["加入我们", "诚聘英才"],
                topImg: require("../assets/img/service1/new_bg.webp"),
                topFont: [
                    // { fontSize: 'normal', value: "诚聘英才" },
                    // { fontSize: 'small', value: "诚聘英才" },

                ],
                content: [
                    { type: 'title', value: '诚聘英才' },
                    {
                        type: 'spaceBetweenMore', value: '',
                        children1: [
                            { type: 'bigTitle', value: '初级嵌入式软件开发工程师' },
                            {
                                type: 'text',
                                value:
                                    '一 、工作内容\n' +
                                    '1、参与嵌入式软件的设计、开发与维护，确保项目按时交付。\n' +
                                    '2、参与系统模块的测试，与团队协作确保软件质量。\n' +
                                    '3、逻辑思维能力强，具有团队合作精神，学习能力强，有责任感，能够有效沟通并攻克技术难题。\n\n' +
                                    '二、任职要求\n' +
                                    '1、熟悉/精通C和C++，或其他编程语言，具备良好的编程习惯。\n' +
                                    '2、计算机、通信、电气/自动化、机械等专业统招本科或以上学历。\n' +
                                    '3、逻辑思维能力强，具有团队合作精神，学习能力强，有责任感，能够有效沟通并攻克技术难题。\n\n'
                            },
                        ],
                        children2: [
                            { type: 'bigTitle', value: '嵌入式应届实习生 ' },
                            {
                                type: 'text', value:
                                    '一 、工作内容\n' +
                                    '1、参与嵌入式软件的设计、开发与维护，确保项目按时交付。\n' +
                                    '2、参与系统模块的测试，与团队协作确保软件质量。\n' +
                                    '3、逻辑思维能力强，具有团队合作精神，学习能力强，有责任感，能够有效沟通并攻克技术难题。\n\n' +
                                    '二、任职要求\n' +
                                    '1、熟悉/精通C和C++，或其他编程语言，具备良好的编程习惯。\n' +
                                    '2、不限专业，统招本科及以上学历应届毕业生。\n' +
                                    '3、逻辑思维能力强，具有团队合作精神，学习能力强，有责任感，能够有效沟通并攻克技术难题。\n' +
                                    '三、实习时长\n' +
                                    '实习期不可少于两个月，表现优异者，实习结束毕业后可申请转正。\n' +
                                    '工作地点：大连高新园区。\n'
                            },
                        ],
                    },
                ]
            }
        }, {
            pageName: "智慧医疗",
            dataId: "p-1-2",
            data: {
                routerList: ["作业领域", "智慧医疗"],
                topImg: require("../assets/img/home1/banner2-1.jpg"),
                topFont: [
                    { fontSize: 'normal', value: "智慧医疗" },
                    // { fontSize: 'small', value: "诚聘英才" },
                ],
                content: [
                    { type: 'title', value: '智慧医疗' },
                    { type: 'bigTitle', value: '信息管理智能化' },
                    { type: 'textImg_left', src: require("../assets/img/industry/xinxiguanli.jpg"), value: '搭建医院信息管理系统和临床信息管理系统，聚焦医院管理与诊疗环节信息化需求，结合新兴技术共同形成院内信息打通；搭建区域/公共卫生信息系统，聚焦医疗机构间的信息共享与交换，通过连接医疗机构、疾控、医保、药品等信息实现医疗卫生数据打通，形成院外信息交互；搭建医保信息管理系统，从国家级、省级、统筹区级三级进行医保信息管理平台建设，通过医保经办、异地结算、基金运行审计、宏观大数据决策等各类功能模块实现医保基金管理闭环；搭建药品信息管理系统，覆盖药品器械的监管追溯、药品的研发生产流通、药店管理等多个环节，提升药品的管理及生产经营效率。为患者、医务人员、医疗机构编织严密的信息网络，构建创新、协作、互联、可靠的智慧医疗新生态。' },
                    { type: 'bigTitle', value: '医疗器械智能化' },
                    { type: 'textImg_left', src: require("../assets/img/industry/yiliaoqixie.jpg"), value: '覆盖生命信息与支持、体外诊断以及医学影像三大领域，深耕智慧彩超成像机、磁共振成像系统、血液细胞分析仪等设备的智能化改造，将大数据、物联网、人工智能、深度学习等前沿科技融入医疗器械研发与改造，将电子信息技术、云计算与生物技术相结合，全力推动国产高端医疗装备的快速产业化，为医生的诊断铸造科技利器，打造更精密、更速度的诊疗闭环。' },
                ]
            }
        }, {
            pageName: "智慧金融",
            dataId: "p-1-3",
            data: {
                routerList: ["作业领域", "智慧金融"],
                topImg: require("../assets/img/home1/banner3-1.jpg"),
                topFont: [
                    { fontSize: 'normal', value: "智慧金融" },
                    // { fontSize: 'small', value: "诚聘英才" },
                ],
                content: [
                    { type: 'title', value: '智慧金融' },
                    { type: "text", value: "凭借多年技术沉淀，根据金融行业特点推出的智能运维解决方案，采用开放式平台架构和松耦合的模块化产品，实现覆盖全渠道的端到端立体化监控网络和基于业务指标的实时可视化管控。依托大数据、智能算法、云计算等科技手段，推出高效的解决方案，帮助券商完成业务智能化革新。覆盖领域从营销、投顾到投研量化和风控各环节，根据客户需求一事一例针对性设计业务场景，全方位赋能券商，帮助其实现业务增长并降低风险。​" },
                    { type: "image", src: require("../assets/img/industry/zhihuicelue.jpg") },
                    { type: 'bigTitle', value: '智慧策略' },
                    { type: 'textImg_left', src: require("../assets/img/industry/zhengquanone.jpg"), value: '基于C++底层架构优势，支持VBA和Python双语言编写策略进行选股和择时以及创建投资组合，提供安全的回测环境和可视化回测模型，让投研更高效。建设统一的数据平台，实现数据的系统化采集与处理，积累更全面的实时信息，满足金融公司对不同类型、不同业务管理方面的分析、预警、展示等个性化需求，提升决策高效性。' },
                    { type: 'bigTitle', value: '行情系统' },
                    { type: 'textImg_left', src: require("../assets/img/industry/zhengquantwo.jpg"), value: '灵活展示多市场、多品种、多周期行情，通过系统录入同期企业level-1行情快照为企业提供当日累计成交量、当日累计成交额、当日成交最高价、当日成交最低价等数据进行比对；同时针对客户推出的level-2的实时行情收费服务进行数据推演。为客户提高行情透明度，增强行情信息，提升竞争力。' },
                    { type: 'bigTitle', value: '量化交易' },
                    { type: 'textImg_left', src: require("../assets/img/industry/lianghuajiaoyi.jpg"), value: '利于智能算法和数学模型，自动分析历史数据、实时行情等信息，根据用户指定的策略场景来决定交易下单的时机。通过强化主动型交易策略，获得超过市场平均水平的收益，通过基本面和技术面的挖掘，提取有效指标进行投资，进而获得超额收益。帮助投资者在交易过程中避免收受到情绪波动的影响，实现最优投资。' },
                    { type: 'bigTitle', value: '智慧风控' },
                    { type: 'textImg_left', src: require("../assets/img/industry/zhengquan04.png"), value: '借助统一大数据分析平台，结合金融公司的业务场景，以风险数据平台+智慧风控为驱动，实现风险分析、风险预警、风险评级等各个方面的有效监控与管理。采用定性和定量相结合的方法，累计数据进行分析；深入各项业务，结合多维筛选方式迅速查看当日开户情况、额度使用情况、融券规模组成结构等关联信息；最后通过实时监控低风险、较低风险、中等风险、较高风险、高风险来源并给出科学性风险建议方案，从而最大程度降低非系统性风险。' },
                ]
            }
        }, {
            pageName: "智慧教育",
            dataId: "p-1-4",
            data: {
                routerList: ["作业领域", "智慧教育"],
                topImg: require("../assets/img/home1/banner4-1.jpg"),
                topFont: [
                    { fontSize: 'normal', value: "智慧教育" },
                    // { fontSize: 'small', value: "诚聘英才" },
                ],
                content: [
                    { type: 'title', value: '智慧教育' },
                    { type: "text", value: "在 5G 与 AI 技术交融的时代，智慧教育打破传统教室边界。课堂中，智能平板替代课本，学生轻点屏幕即可查阅 3D 动态知识图谱；教师借助 AI 学情分析系统，实时捕捉每位学生的专注度曲线，精准推送分层习题。校园走廊的智慧屏化身 “知识驿站”，通过人脸识别推送个性化学习资源，午休时的碎片时间也能沉浸于 AR 历史场景漫游。" },
                    { type: "text", value: "家校共育环节，智能手环同步学生运动心率与课堂表现，家长手机端可直观查看成长轨迹；云端作业系统自动批改主观题，红笔批注附上微课解析，错题本实现跨学期智能归档。更深远的是，偏远山区的孩子能通过全息投影与一线城市名师 “同框” 上课，教育公平在数据流动中悄然生长。" },
                    { type: "text", value: "智慧教育不仅是技术赋能，更是一场思维革命 —— 从 “千人一面” 的填鸭式教学，转向以学习者为中心的个性化成长生态，让每个求知的灵魂都能在数字沃土中找到绽放的路径。" },
                ]
            }
        }, {
            pageName: "内容管理平台",
            dataId: "p-1-5",
            data: {
                routerList: ["作业领域", "内容管理平台"],
                topImg: require("../assets/img/home1/banner5-1.jpg"),
                topFont: [
                    { fontSize: 'normal', value: "内容管理平台" },
                    // { fontSize: 'small', value: "诚聘英才" },
                ],
                content: [
                    { type: 'title', value: '高效管理，智创未来——XX内容管理平台，让内容创造无限可能！' },
                    { type: "bigTitle", value: "一站式内容管理解决方案，助力企业高效运营与增长" },
                    { type: "text", value: "在数字化时代，内容是企业增长的核心动力。无论您是品牌营销、新闻媒体、电子商务还是教育培训，XX内容管理平台都能为您提供强大、灵活且安全的内容管理体验，助您轻松驾驭海量内容，释放团队创造力！" },
                    { type: "bigTitle", value: "为什么选择XX内容管理平台？" },
                    { type: "text", value: "✅ 智能高效：直观的操作界面与强大的编辑工具，让内容创作、编辑、发布一气呵成，效率提升50%以上。\n✅ 多端协同：支持PC、移动端及第三方平台无缝对接，团队协作更流畅，随时随地管理内容。\n✅ 安全可靠：多层加密与权限管理，保障数据安全，审计追踪让每一步操作都有迹可循。\n✅ 灵活扩展：模块化设计，可根据业务需求自由定制功能，轻松应对未来挑战。\n✅ 数据分析：内置智能分析工具，实时追踪内容表现，优化策略，驱动业务增长。" },
                    { type: "bigTitle", value: "适用场景：" },
                    { type: "text", value: "1.企业官网与品牌内容管理\n2.电商产品与营销活动更新\n3.媒体机构多平台内容分发\n4.教育机构课程与资源管理\n" },
                ]
            }
        }, {
            pageName: "Saas平台",
            dataId: "p-1-6",
            data: {
                routerList: ["作业领域", "Saas平台"],
                topImg: require("../assets/img/home1/banner6-1.jpg"),
                topFont: [
                    // { fontSize: 'normal', value: "Saas平台" },
                    // { fontSize: 'small', value: "诚聘英才" },
                ],
                content: [
                    { type: 'title', value: 'Saas平台' },
                    { type: "text", value: "SaaS 即软件即服务，是一种基于云的软件交付模式。在这种模式下，软件托管在远程服务器上，由服务提供商维护和更新，并通过 Web 浏览器、移动应用程序和 API 提供给客户。用户无需在本地安装软件，只需通过互联网即可便捷使用。" },
                    { type: "text", value: "SaaS 平台的工作模式颇具特色。供应商在自家或第三方服务器和数据库托管应用程序与数据，并管理平台、操作系统和中间件。用户订阅后，凭借注册登录信息经 Web 浏览器获得应用程序访问权限。通常采用多租户模型，即单一版本软件供众多订阅用户使用，同时保障各用户数据相互隔离。" },
                    { type: "text", value: "其类型丰富多样，常见的涵盖会计 SaaS，像 Xero、QuickBooks 可自动化简化财务运营；内容管理系统（CMS），助力管理数字内容创建修改；客户关系管理（CRM），用于存储管理客户数据，如 Salesforce；企业资源规划（ERP），管理包括会计、风险管理等广泛业务流程；项目管理 SaaS，帮助组织计划、执行和监控项目；通信 SaaS，实现成员即时消息传递和文件共享；人力资源 SaaS（HR/HRM），具备招聘、绩效跟踪等人力资源管理功能；支付网关 SaaS，让企业能便捷接受付款 。" },
                    { type: 'text', value: 'SaaS 平台为企业带来了显著优势，成本可预测且开销降低，无需投入大量资金在基础架构与软件升级；能实现无摩擦升级与更新，供应商可实时更新软件；支持随时随地访问应用数据，数据存储在云端，设备故障也不担心数据丢失；具备快速可扩展性，用户可按需灵活调整使用层级 。' },
                ]
            }
        }, {
            pageName: "news1",
            dataId: "n-1-1",
            data: {
                routerList: ["新闻"],
                topImg: require("../assets/img/aboutUs/company1.png"),
                topFont: [
                    // { fontSize: 'normal', value: "Saas平台" },
                    // { fontSize: 'small', value: "诚聘英才" },
                ],
                content: [
                    { type: 'firstTitle', value: '资质|八比特科技顺利通过CMMl3级认证', layout: 'center', margin: '0 0 60px 0' },
                    // { type: 'image', src: require("../assets/img/news/news_1_1.png") },
                    {
                        type: 'spaceBetweenMore', value: '',
                        children1: [
                            { type: "text", textIndent: '2em', value: "2025年01月20日，大连八比特科技有限公司成功获取CMMI 3级认证，此资质彰显了八比特科技在软件研发实力、流程组织能力、服务实施交付效率及项目管理水平等方面均已达到业界前沿，再次印证了公司秉持匠心精神推动科技进步的坚定步伐。这一认证不仅为八比特科技进军国际市场奠定了坚实基础，更显著增强了公司的竞争优势，进一步稳固了其在行业中的领先地位。" },
                        ],
                        children2: [
                            { type: 'image', src: require("../assets/img/news/news_1_1.png"), name: "图|大连八比特科技通过 CMMI 3 级认证" },
                        ],
                    },
                    {
                        type: 'spaceBetweenMore', value: '',
                        children1: [
                            { type: "text", textIndent: '2em', value: "CMMI，全称为Capability Maturity Model Integration（能力成熟度模型集成），是一项在全球范围内推广应用的软件能力成熟度评估体系，旨在引导软件开发过程的持续优化，并对软件开发能力进行科学评估。其中，CMMI 3级认证标志着企业已构建起一套成熟完善的软件过程管理体系，展现出高度的规范性、稳定性和可重复性，能够稳定且持续地提供高质量的软件产品及服务。" },
                        ],
                        children2: [
                            { type: 'image', src: require("../assets/img/news/news_1_2.png") },
                        ],
                    },
                    {
                        type: 'spaceBetweenMore', value: '',
                        children1: [
                            { type: "text", textIndent: '2em', value: "近年来，八比特科技有限公司秉持“探索未来科技，创新智慧生活”的企业愿景，矢志成为“卓越的智能技术方案提供商”。公司深入聚焦软件开发的关键领域，精心打造量身定制的解决方案，并严格参照CMMI 3.0模型，主动开展现状评估与全面分析。" },
                        ],
                        children2: [
                            { type: 'image', src: require("../assets/img/news/news_1_3.png"), name: "图|大连八比特科技通过 CMMI 3 级认证" },
                        ],
                    },
                    {
                        type: 'spaceBetweenMore', value: '',
                        children1: [
                            { type: "text", textIndent: '2em', value: "在此基础上，公司依托数据驱动对软件开发流程进行优化改进，并量化评估改进成效，从而显著提升了软件研发的效率与质量。最终在各实践域达到并通过 CMMI 3级评估要求。" },
                        ],
                        children2: [
                            { type: 'image', src: require("../assets/img/news/news_1_4.png"), name: "图|大连八比特科技通过 CMMI 3 级认证" },
                        ],
                    },
                    // { type: 'image', src: require("../assets/img/news/news_1_4.png"), name: "图|大连八比特科技通过 CMMI 3 级认证" },

                    // { type: 'bigTitle', value: '关于八比特科技' },
                    // { type: "text", value: "八比特科技有限公司作为一家专注于智能技术研发的创新型科技企业、国家高新技术企业、专精特新企业、车联网企业、大连市车联网产业创新联盟成员，基于积累多年的嵌入式操作系统优化技术、人机交互、机器视觉、以及语音和音频技术，为汽车提供从操作系统开发到应用定制，包括汽车信息娱乐系统、智能仪表盘、集成驾驶舱和音频产品在内的整体智能座舱系统解决方案和技术服务，为驾乘者提供丰富、先进的智能驾驶体验。" },
                    // { type: "text", value: "展望未来，八比特科技有限公司将顺应企业成长趋势，由“成为卓越的智能技术方案提供商”这一愿景向深化自主产品研发领域聚焦，以汇聚力量、激发潜能。此番顺利荣获CMMI 3级认证，不仅是八比特科技长期坚持技术创新、高度重视研发管理体系建设的结晶，也是对公司实力与努力的权威认可。以此为契机，八比特科技将矢志不渝地优化研发流程，精进项目管理效能，致力于为客户提供更加卓越的产品与服务，从而在激烈的市场竞争中不断锤炼并提升自身的核心竞争力。" },
                ]
            }
        }, {
            pageName: "news2",
            dataId: "n-1-2",
            data: {
                routerList: ["新闻"],
                topImg: require("../assets/img/aboutUs/company1.png"),
                topFont: [
                    // { fontSize: 'normal', value: "Saas平台" },
                    // { fontSize: 'small', value: "诚聘英才" },
                ],
                content: [
                    { type: 'title', value: '秉初心 再奋进 励新程|八比特科技参加2025大连软件产业发展大会并荣获双奖', margin: '0 0 60px 0' },
                    {
                        type: 'spaceBetweenMore', value: '',
                        children1: [
                            { type: "text", textIndent: '2em', value: "2025年1月15日，2025大连软件产业发展大会于星海世博广场成功举办，大连八比特科技有限公司应邀参会，并获得“车联网创新企业”“优秀软件产品”两项荣誉。" },
                            { type: "text", textIndent: '2em', value: "大会遵循政府的指导方针，同时邀请了大连软件行业协会的各位领导及行业同仁进行主题演讲，共同探索产业发展的最新趋势，深切体会企业家们的奋斗与进取精神。会上共同探讨2024大连软件产业发展现状和机遇、大连车联网产业发展现状和机遇、中小企业数字化转型实施实践与体会的课题；同时宣布大连软件行业可信IT圈平台的发布，倡导业内同仁携手合作、团结互助，共同发掘产业的新机遇，探索互利共赢的合作可能。" },
                        ],
                        children2: [
                            { type: 'image', src: require("../assets/img/news/news_2_1.png") },
                        ],
                    },
                    {
                        type: 'spaceBetweenMore', value: '',
                        children1: [
                            { type: "text", textIndent: '2em', value: "大会同时对各企业表彰颁奖，大连八比特科技有限公司被评为2024年大连软件和信息技术服务业“车联网创新企业”，其开发的“ReallnsightV4.0车载开发框架”荣获2024年大连软件和信息技术服务优秀软件产品奖项。" },
                            { type: 'text', textIndent: '2em', value: '本次会议的圆满举行，极大地提振了大连软件企业团队的士气，并激发了大连软件产业创新活力的源泉。会上，八比特科技携手众多软件企业，深入探讨了大连软件产业的未来走向。展望未来，各方将携手并进，为产业的蓬勃发展和繁荣壮大贡献各自的力量。' },
                        ],
                        children2: [
                            { type: 'image', src: require("../assets/img/news/news_2_2.jpg"), name: "图|2025大连软件产业发展大会" },

                        ],
                    },

                    { type: 'firstTitle', value: '表彰颁奖', layout: "center" },
                    {
                        type: 'spaceBetweenMore', value: '',
                        children1: [
                            { type: 'allImage', src: require("../assets/img/news/news_2_3.jpg"), name: "图|大连八比特被评为2024年车联网创新企业" },
                        ],
                        children2: [
                            { type: 'allImage', src: require("../assets/img/news/news_2_4.jpg"), name: "图|“ReallnsightV4.0车载开发框架”荣获优秀软件产品奖项" },
                        ],
                    },
                    {
                        type: 'spaceBetweenMore', value: '',
                        children1: [
                            { type: 'allImage', src: require("../assets/img/news/news_2_5.jpg"), },
                        ],
                        children2: [
                            { type: 'allImage', src: require("../assets/img/news/news_2_6.jpg"), },
                        ],
                    },

                ]
            }
        }, {
            pageName: "news3",
            dataId: "n-1-3",
            data: {
                routerList: ["新闻"],
                topImg: require("../assets/img/aboutUs/company1.png"),
                topFont: [
                    // { fontSize: 'normal', value: "Saas平台" },
                    // { fontSize: 'small', value: "诚聘英才" },
                ],
                content: [
                    { type: 'title', value: '喜报|八比特旗下两家企业再获国家高新技术企业认定' },
                    {
                        type: 'spaceBetweenMore', value: '',
                        children1: [
                            { type: "text", textIndent: '2em', value: "2024年12月24日，全国高新技术企业认定管理工作领导小组办公室对大连市认定机构2024年认定报备的第一批高新技术企业进行备案公示。" },
                            { type: "text", textIndent: '2em', value: "其中，八比特科技旗下两家企业：大连八比特科技有限公司、八比智行（大连）科技有限公司荣获本次国家高新技术企业认定。大连八比特科技有限公司已经连续三次评定为国家高新技术企业，而八比智行（大连）科技有限公司是八比特旗下第四家高新技术企业。" },
                        ],
                        children2: [
                            { type: 'allImage', src: require("../assets/img/news/news_3_1.png"), name: "图|对大连市认定机构2024年认定报备的\n第一批高新技术企业进行备案的公示" },
                        ],
                    },
                    {
                        type: 'spaceBetweenMore', value: '',
                        children1: [
                            { type: "text", value: "高新技术企业是指在《国家重点扶持的高新技术领域》中，不断致力于研究开发活动与技术成果的有效转化，从而构建起企业自身的核心自主知识产权体系，并以此作为业务发展的基石。这类企业往往表现为知识与技术高度集中的经济实体，拥有出色的研发实力和技术先进性，其提供的产品、采用的技术或提供的服务均隶属于高新技术领域。" },

                        ],
                        children2: [
                            { type: 'allImage', src: require("../assets/img/news/news_3_2.png"), },
                            { type: 'allImage', src: require("../assets/img/news/news_3_3.png"), name: "图|八比特旗下两家企业认定公示" },
                        ],
                    },
                ]
            }
        }, {
            pageName: "news4",
            dataId: "n-1-4",
            data: {
                routerList: ["新闻"],
                topImg: require("../assets/img/aboutUs/company1.png"),
                topFont: [
                    // { fontSize: 'normal', value: "Saas平台" },
                    // { fontSize: 'small', value: "诚聘英才" },
                ],
                content: [
                    { type: 'title', value: '车联网协会|大连八比特任第三届副理事长单位' },
                    {
                        type: 'spaceBetweenMore', value: '',
                        children1: [
                            {
                                type: 'bigTitle', value: '大连软件行业协会车联网分会', margin: '0 0 20px 0'
                                // layout: 'center'
                            },
                            { type: 'smallTitle', value: '2024会员大会', margin: '0 0 10px 0', },
                            { type: 'smallTitle', value: '大连市车联网产业创新联盟', margin: '0 0 40px 0', },
                            { type: "text", margin: '0 0 0px 0', value: "2024年12月26日，大连软件行业协会车联网分会于高新区成功举办了2024会员大会，大连八比特科技有限公司受邀出席大会。" },
                            { type: "text", value: "会上，分会就项目对接、人才培养、合作交流、产业发展调研等核心工作进行了成果汇报，并发布了新一年的工作计划，同时进行了第三届理事会的选举工作。" },

                        ],
                        children2: [
                            { type: 'image80', src: require("../assets/img/news/news_4_1.png"), name: "图|大连软件行业协会车联网分会2024会员大会" },
                        ],
                    },

                    { type: "firstTitle", value: "大连八比特出任理事会副理事长单位" ,layout:'center'},
                    { type: 'smallTitle' ,layout:'center', value: "根据《大连软件行业协会车联网分会章程》，经选举投票，大连八比特科技有限公司成功当选为第三届理事会的副理事长单位。"},
                    // { type: 'image80', src: require("../assets/img/news/news_4_2.png") },
                    {
                        type: 'twoImage', count: 2,
                        srcList: [
                            { name: null, src: require("../assets/img/news/news_4_2.png") },
                            { name: null, src: require("../assets/img/news/news_4_4.png") },]
                    },
                    // {
                    //     type: 'spaceBetweenMore', value: '',
                    //     children1: [
                    //         { type: 'image', src: require("../assets/img/news/news_4_2.png") },
                    //     ],
                    //     children2: [
                    //         { type: 'image', src: require("../assets/img/news/news_4_4.png") },
                    //     ],
                    // },
                ]
            }
        }, {
            pageName: "企业数字化转型",
            dataId: "solution-1",
            data: {
                routerList: ["解决方案", "企业数字化转型"],
                topImg: require("../assets/img/banner2.jpg"),
                topFont: [
                    { fontSize: 'normal', value: "企业数字化转型" },
                ],
                content: [
                    { type: 'title', value: '企业数字化转型解决方案' },
                    { type: 'text', value: '企业数字化转型是指利用数字技术彻底改变企业的业务流程、组织结构、产品服务和商业模式，以提升企业的运营效率、创新能力和市场竞争力。我们的数字化转型解决方案帮助企业实现从传统运营模式向数字化、智能化运营模式的转变。' },
                    { type: 'bigTitle', value: '核心服务' },
                    { type: 'text', value: '(1)数字化战略规划：根据企业现状和目标，制定符合企业发展的数字化转型战略和实施路径。' },
                    { type: 'text', value: '(2)业务流程优化：梳理和优化现有业务流程，消除冗余环节，提升流程效率和质量。' },
                    { type: 'text', value: '(3)技术平台建设：搭建企业级数字化平台，包括云平台、数据平台、应用平台等基础设施。' },
                    { type: 'text', value: '(4)数据治理与分析：建立完善的数据治理体系，实现数据的采集、存储、分析和应用。' },
                    { type: 'text', value: '(5)组织能力提升：培养数字化人才，建立数字化组织文化和协作机制。' },
                    { type: 'text', value: '(6)安全保障体系：构建全方位的网络安全和数据安全防护体系。' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '制造业、零售业、金融业、物流业、医疗健康、教育培训、政府机构' },
                ]
            }
        }, {
            pageName: "智慧园区解决方案",
            dataId: "cloud-2",
            data: {
                routerList: ["解决方案", "智慧园区解决方案"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    { fontSize: 'normal', value: "智慧园区解决方案" },
                ],
                content: [
                    { type: 'title', value: '智慧园区解决方案' },
                    { type: 'text', value: '智慧园区解决方案利用物联网、大数据、人工智能等先进技术，将园区内的基础设施、公共服务、安全管理、能源管理等各个方面进行智能化升级，打造安全、高效、便捷、绿色的现代化园区。' },
                    { type: 'bigTitle', value: '核心功能' },
                    { type: 'text', value: '(1)智能安防：视频监控、人脸识别、入侵检测、智能巡检，全方位保障园区安全。' },
                    { type: 'text', value: '(2)智慧停车：智能车位引导、车牌识别、无感支付，提升停车体验和效率。' },
                    { type: 'text', value: '(3)能源管理：实时监测能耗，智能调节空调、照明等设备，实现节能减排。' },
                    { type: 'text', value: '(4)环境监测：监测空气质量、温湿度、噪音等环境指标，营造舒适环境。' },
                    { type: 'text', value: '(5)智能办公：会议室预订、访客管理、智能门禁，提升办公效率。' },
                    { type: 'text', value: '(6)应急指挥：统一调度、快速响应，提升突发事件处理能力。' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '科技园区、产业园区、工业园区、商业园区、物流园区、校园园区' },
                ]
            }
        }, {
            pageName: "智慧校园解决方案",
            dataId: "solution-3",
            data: {
                routerList: ["解决方案", "智慧校园解决方案"],
                topImg: require("../assets/img/banner2.jpg"),
                topFont: [
                    { fontSize: 'normal', value: "智慧校园解决方案" },
                ],
                content: [
                    { type: 'title', value: '智慧校园解决方案' },
                    { type: 'text', value: '智慧校园解决方案通过信息技术与教育教学的深度融合，构建数字化、网络化、智能化的校园环境，提升教学质量和学习效率，优化校园管理和服务，为师生创造更加便捷、安全、舒适的学习生活环境。' },
                    { type: 'bigTitle', value: '核心功能' },
                    { type: 'text', value: '(1)智慧教学：多媒体教室、在线教学平台、互动教学工具，丰富教学手段。' },
                    { type: 'text', value: '(2)智慧管理：学生管理、教师管理、教务管理、资产管理，提升管理效率。' },
                    { type: 'text', value: '(3)智慧服务：一卡通、智能图书馆、智能食堂、智能快递，便捷校园生活。' },
                    { type: 'text', value: '(4)智慧安防：校园监控、门禁管理、访客管理、应急报警，保障校园安全。' },
                    { type: 'text', value: '(5)智慧环境：智能照明、智能空调、环境监测，营造舒适学习环境。' },
                    { type: 'text', value: '(6)家校互通：家校沟通平台、学生成长档案，促进家校协同育人。' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '高等院校、中小学、职业院校、培训机构、幼儿园' },
                ]
            }
        }, {
            pageName: "汽车安全解决方案",
            dataId: "solution-4",
            data: {
                routerList: ["解决方案", "汽车安全解决方案"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    { fontSize: 'normal', value: "汽车安全解决方案" },
                ],
                content: [
                    { type: 'title', value: '汽车安全解决方案' },
                    { type: 'text', value: '汽车安全解决方案涵盖主动安全、被动安全、信息安全等多个维度，通过先进的传感器技术、人工智能算法和网络安全防护，为驾乘人员提供全方位的安全保障，降低交通事故风险，提升行车安全水平。' },
                    { type: 'bigTitle', value: '核心功能' },
                    { type: 'text', value: '(1)主动安全：自适应巡航、自动紧急制动、车道保持、盲区监测，预防事故发生。' },
                    { type: 'text', value: '(2)被动安全：高强度车身结构、多安全气囊、预紧式安全带，减轻事故伤害。' },
                    { type: 'text', value: '(3)驾驶员监测：疲劳监测、分心监测、情绪识别，提醒驾驶员保持专注。' },
                    { type: 'text', value: '(4)环境感知：毫米波雷达、激光雷达、摄像头，实时感知周围环境。' },
                    { type: 'text', value: '(5)网络安全：入侵检测、数据加密、安全通信，防止网络攻击。' },
                    { type: 'text', value: '(6)应急救援：自动报警、事故记录、紧急呼叫，快速响应事故。' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '乘用车、商用车、新能源汽车、自动驾驶车辆、特种车辆' },
                ]
            }
        }, {
            pageName: "智慧俱乐部",
            dataId: "enterprise-1",
            data: {
                routerList: ["企业应用", "智慧俱乐部"],
                topImg: require("../assets/img/banner2.jpg"),
                topFont: [
                    { fontSize: 'normal', value: "智慧俱乐部" },
                ],
                content: [
                    { type: 'title', value: '智慧俱乐部解决方案' },
                    { type: 'text', value: '智慧俱乐部解决方案利用物联网、大数据、人工智能等先进技术，将俱乐部的会员管理、场地预订、设备管理、活动组织等各个方面进行智能化升级，打造便捷、高效、智能的现代化俱乐部管理平台。' },
                    { type: 'bigTitle', value: '核心功能' },
                    { type: 'text', value: '(1)会员管理：会员注册、会员等级、积分管理、会员权益，提升会员粘性。' },
                    { type: 'text', value: '(2)场地预订：在线预订、实时查看、智能排期、自动结算，提升场地利用率。' },
                    { type: 'text', value: '(3)设备管理：设备预约、设备维护、设备监控、设备统计，延长设备寿命。' },
                    { type: 'text', value: '(4)活动组织：活动发布、活动报名、活动签到、活动评价，提升活动效果。' },
                    { type: 'text', value: '(5)数据分析：会员分析、场地分析、活动分析、收入分析，辅助决策。' },
                    { type: 'text', value: '(6)智能支付：在线支付、会员卡支付、二维码支付，便捷支付体验。' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '健身俱乐部、羽毛球俱乐部、网球俱乐部、游泳俱乐部、高尔夫俱乐部、乒乓球俱乐部' },
                ]
            }
        }, {
            pageName: "智慧场馆",
            dataId: "enterprise-2",
            data: {
                routerList: ["企业应用", "智慧场馆"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    { fontSize: 'normal', value: "智慧场馆" },
                ],
                content: [
                    { type: 'title', value: '智慧场馆解决方案' },
                    { type: 'text', value: '智慧场馆解决方案利用物联网、大数据、人工智能等先进技术，将场馆的票务管理、入场管理、场地管理、设备管理、安全管理等各个方面进行智能化升级，打造安全、高效、便捷、绿色的现代化场馆。' },
                    { type: 'bigTitle', value: '核心功能' },
                    { type: 'text', value: '(1)票务管理：在线购票、电子票、二维码验票、退改签，提升购票体验。' },
                    { type: 'text', value: '(2)入场管理：人脸识别、身份证验证、二维码扫描、智能闸机，快速入场。' },
                    { type: 'text', value: '(3)场地管理：场地预订、场地排期、场地监控、场地维护，提升场地利用率。' },
                    { type: 'text', value: '(4)设备管理：设备监控、设备维护、设备预警、设备统计，延长设备寿命。' },
                    { type: 'text', value: '(5)安全管理：视频监控、入侵检测、消防监测、应急指挥，保障场馆安全。' },
                    { type: 'text', value: '(6)数据分析：客流分析、收入分析、活动分析、设备分析，辅助决策。' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '体育场馆、会展中心、剧院、音乐厅、展览馆、博物馆' },
                ]
            }
        },
        {
            pageName: "Autosar技术服务",
            dataId: "service-1-1",
            data: {
                routerList: ["服务", "软件技术服务", "Autosar技术服务"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    { fontSize: 'normal', value: "Autosar技术服务" },
                ],
                content: [
                    { type: 'title', value: 'Autosar技术服务' },
                    { type: 'text', value: 'AUTOSAR（AUTomotive Open System ARchitecture）是全球汽车行业广泛采用的开放式标准化软件架构。我们提供完整的AUTOSAR开发服务，帮助客户构建符合国际标准的汽车电子软件系统，提升开发效率、降低开发成本、增强系统可靠性。' },
                    { type: 'bigTitle', value: '服务内容' },
                    { type: 'text', value: '(1)AUTOSAR CP（Classic Platform）开发：提供基于AUTOSAR CP架构的ECU软件开发服务，包括BSW（基础软件）、RTE（运行时环境）和应用层软件开发。' },
                    { type: 'text', value: '(2)AUTOSAR AP（Adaptive Platform）开发：提供基于AUTOSAR AP架构的高性能计算平台开发服务，支持面向服务的架构设计。' },
                    { type: 'text', value: '(3)工具链支持：支持Davinci、Vector、ETAS等主流AUTOSAR工具链，提供工具选型、配置和集成服务。' },
                    { type: 'text', value: '(4)国产化方案：适配普华ORIENTAIS AUTOSAR工具链，联合紫光国微、智芯科技打造RISC-V架构MCU解决方案，关键模块自主可控率100%。' },
                    { type: 'bigTitle', value: '核心优势' },
                    { type: 'text', value: '(1)全栈开发能力：从需求分析、架构设计到代码实现、测试验证，提供端到端开发服务。' },
                    { type: 'text', value: '(2)丰富项目经验：累计完成100+个AUTOSAR项目，涵盖车身控制、底盘控制、动力总成等多个领域。' },
                    { type: 'text', value: '(3)专业团队：拥有50+名AUTOSAR认证工程师，平均从业经验8年以上。' },
                    { type: 'text', value: '(4)快速交付：采用模块化开发模式，开发周期缩短30%以上。' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '车身控制器、网关、动力总成、底盘控制、新能源管理、智能驾驶域控制器' },
                ]
            }
        },
        {
            pageName: "视觉识别技术服务",
            dataId: "service-1-2",
            data: {
                routerList: ["服务", "软件技术服务", "视觉识别技术服务"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    { fontSize: 'normal', value: "视觉识别技术服务" },
                ],
                content: [
                    { type: 'title', value: '视觉识别技术服务' },
                    { type: 'text', value: '视觉识别技术是人工智能的重要分支，通过计算机视觉算法实现对图像和视频的智能分析。我们提供从算法设计、模型训练到工程落地的全流程视觉识别服务，帮助客户构建智能视觉系统。' },
                    { type: 'bigTitle', value: '服务内容' },
                    { type: 'text', value: '(1)目标检测：提供人脸检测、车辆检测、行人检测、物体检测等多种目标检测算法，支持实时检测和多目标追踪。' },
                    { type: 'text', value: '(2)图像分割：提供语义分割、实例分割、全景分割等服务，实现对图像像素级别的精细分类。' },
                    { type: 'text', value: '(3)行为识别：提供人体姿态估计、行为分析、异常行为检测等服务，适用于安防监控、智能驾驶等场景。' },
                    { type: 'text', value: '(4)OCR识别：提供文字检测、文字识别、票据识别等服务，支持中英文及多语言识别。' },
                    { type: 'bigTitle', value: '核心优势' },
                    { type: 'text', value: '(1)高精度算法：采用深度学习技术，识别准确率达到99%以上。' },
                    { type: 'text', value: '(2)实时性能：优化算法架构，支持1080P视频实时处理，延迟低于50ms。' },
                    { type: 'text', value: '(3)轻量化部署：提供模型压缩和量化服务，支持在嵌入式设备上高效运行。' },
                    { type: 'text', value: '(4)场景适配：针对不同应用场景进行算法优化，提升实际效果。' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '智能安防、自动驾驶、工业质检、医疗影像、智能零售、智慧交通' },
                ]
            }
        },
        {
            pageName: "OTA技术服务",
            dataId: "service-1-3",
            data: {
                routerList: ["服务", "软件技术服务", "OTA技术服务"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    { fontSize: 'normal', value: "OTA技术服务" },
                ],
                content: [
                    { type: 'title', value: 'OTA技术服务' },
                    { type: 'text', value: 'OTA（Over-The-Air）技术是智能终端远程升级的核心技术，通过无线网络实现固件和软件的远程更新。我们提供完整的OTA解决方案，帮助客户构建安全、高效、可靠的远程升级体系。' },
                    { type: 'bigTitle', value: '服务内容' },
                    { type: 'text', value: '(1)OTA平台搭建：提供基于云计算的OTA管理平台，支持设备管理、版本管理、升级策略配置等功能。' },
                    { type: 'text', value: '(2)差分升级技术：采用自研差分算法，升级包体积减少80%以上，大幅降低流量消耗和升级时间。' },
                    { type: 'text', value: '(3)安全防护体系：基于PKI/CA体系实现双向身份认证，支持国密算法（SM2/SM3/SM4），确保升级过程安全可靠。' },
                    { type: 'text', value: '(4)多平台支持：支持汽车、手机、平板、物联网设备等多种智能终端的OTA升级。' },
                    { type: 'bigTitle', value: '核心优势' },
                    { type: 'text', value: '(1)高并发能力：支持千万级设备接入，1W+设备并行下载，升级效率行业领先。' },
                    { type: 'text', value: '(2)高可靠性：具备断点续传、程序回滚、多分区升级等功能，升级成功率99.9%以上。' },
                    { type: 'text', value: '(3)灵活部署：支持公有云、私有云、混合云等多种部署方式，满足不同客户需求。' },
                    { type: 'text', value: '(4)完整合规：通过OMA-DM标准认证，满足车联网安全要求。' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '整车OTA、ECU升级、车载系统升级、手机系统升级、物联网设备升级' },
                ]
            }
        },
        {
            pageName: "产品测试服务",
            dataId: "service-2-1",
            data: {
                routerList: ["服务", "专业测试服务", "产品测试服务"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    { fontSize: 'normal', value: "产品测试服务" },
                ],
                content: [
                    { type: 'title', value: '产品测试服务' },
                    { type: 'text', value: '产品测试是保证产品质量的重要环节，我们提供全方位的测试服务，从功能测试、性能测试到安全测试，帮助客户发现并解决产品缺陷，提升产品质量和用户体验。' },
                    { type: 'bigTitle', value: '服务内容' },
                    { type: 'text', value: '(1)功能测试：提供完整的功能测试服务，包括单元测试、集成测试、系统测试、验收测试等，确保产品功能符合需求。' },
                    { type: 'text', value: '(2)性能测试：提供压力测试、负载测试、稳定性测试等服务，评估产品在高并发、大数据量场景下的表现。' },
                    { type: 'text', value: '(3)兼容性测试：提供多平台、多浏览器、多设备的兼容性测试服务，确保产品在不同环境下正常运行。' },
                    { type: 'text', value: '(4)安全测试：提供漏洞扫描、渗透测试、代码审计等服务，发现并修复安全隐患。' },
                    { type: 'bigTitle', value: '核心优势' },
                    { type: 'text', value: '(1)专业测试团队：拥有100+名测试工程师，平均从业经验5年以上，具备丰富的测试经验。' },
                    { type: 'text', value: '(2)完善测试流程：建立标准化的测试流程和质量管理体系，确保测试质量。' },
                    { type: 'text', value: '(3)自动化测试：采用自动化测试工具和框架，提高测试效率，缩短测试周期。' },
                    { type: 'text', value: '(4)快速响应：提供7x24小时测试服务，紧急需求24小时内响应。' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '软件产品测试、硬件产品测试、系统集成测试、移动应用测试、Web应用测试' },
                ]
            }
        },
        {
            pageName: "应用系统服务",
            dataId: "service-2-2",
            data: {
                routerList: ["服务", "专业测试服务", "应用系统服务"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    { fontSize: 'normal', value: "应用系统服务" },
                ],
                content: [
                    { type: 'title', value: '应用系统服务' },
                    { type: 'text', value: '应用系统是企业数字化转型的核心载体，我们提供从需求分析、系统设计、开发实施到运维支持的全生命周期服务，帮助客户构建高效、稳定、安全的应用系统。' },
                    { type: 'bigTitle', value: '服务内容' },
                    { type: 'text', value: '(1)企业应用开发：提供ERP、CRM、OA、HR等企业级应用系统的定制开发服务，满足企业个性化需求。' },
                    { type: 'text', value: '(2)移动应用开发：提供iOS、Android、小程序等移动应用开发服务，覆盖主流移动平台。' },
                    { type: 'text', value: '(3)Web应用开发：提供企业官网、电商平台、SaaS平台等Web应用开发服务，支持高并发访问。' },
                    { type: 'text', value: '(4)系统集成服务：提供多系统集成、数据迁移、接口开发等服务，打通信息孤岛。' },
                    { type: 'bigTitle', value: '核心优势' },
                    { type: 'text', value: '(1)技术实力雄厚：掌握Java、Python、Node.js、Go等多种开发技术，能够满足不同技术栈需求。' },
                    { type: 'text', value: '(2)丰富行业经验：在金融、医疗、教育、制造等多个行业拥有成功案例，深入了解行业特性。' },
                    { type: 'text', value: '(3)敏捷开发模式：采用Scrum敏捷开发方法，快速响应需求变化，缩短交付周期。' },
                    { type: 'text', value: '(4)完善售后支持：提供7x24小时技术支持，快速响应并解决客户问题。' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '企业管理系统、业务系统、数据平台、移动应用、Web应用' },
                ]
            }
        },
        {
            pageName: "移动终端自动化测试平台",
            dataId: "service-2-3",
            data: {
                routerList: ["服务", "专业测试服务", "移动终端自动化测试平台"],
                topImg: require("../assets/img/banner3.webp"),
                topFont: [
                    { fontSize: 'normal', value: "移动终端自动化测试平台" },
                ],
                content: [
                    { type: 'title', value: '移动终端自动化测试平台' },
                    { type: 'text', value: '移动终端自动化测试平台是专为移动应用测试打造的智能化测试平台，通过自动化测试技术和云端设备管理，大幅提升测试效率，降低测试成本，保证移动应用质量。' },
                    { type: 'bigTitle', value: '平台功能' },
                    { type: 'text', value: '(1)设备管理：支持云端管理数百台真机设备，覆盖iOS、Android主流机型，支持设备预约、远程控制、设备监控等功能。' },
                    { type: 'text', value: '(2)自动化测试：提供UI自动化测试、接口测试、性能测试等多种自动化测试服务，支持脚本录制和回放。' },
                    { type: 'text', value: '(3)兼容性测试：一键发起多设备兼容性测试，自动生成测试报告，快速发现兼容性问题。' },
                    { type: 'text', value: '(4)性能监控：实时监控应用性能指标，包括启动时间、内存占用、CPU使用率、网络流量等。' },
                    { type: 'bigTitle', value: '核心优势' },
                    { type: 'text', value: '(1)高效便捷：支持7x24小时自动化测试，测试效率提升10倍以上。' },
                    { type: 'text', value: '(2)覆盖全面：设备库覆盖200+主流机型，覆盖率达95%以上。' },
                    { type: 'text', value: '(3)智能分析：AI驱动的测试分析引擎，自动识别异常，智能定位问题。' },
                    { type: 'text', value: '(4)灵活部署：支持公有云、私有云、本地部署等多种部署方式。' },
                    { type: 'bigTitle', value: '应用场景' },
                    { type: 'text', value: '移动应用测试、游戏测试、兼容性测试、性能测试、回归测试' },
                ]
            }
        },

    ])

//获取详情信息
export function getDetailData(dataId) {
    let data = detailDataList.value.find(item => item.dataId === dataId) || null;
    return data.data
}


//路由跳转
export function routerTo(path, data) {
    router.push({
        path: path,
        query: data
    }
    )
    return
}